export default {
    // Common
    save: 'Ruaj',
    saving: 'Po ruhet…',
    cancel: 'Anulo',
    delete: 'Fshi',
    edit: 'Ndrysho',
    view: 'Shiko',
    create: 'Krijo',
    remove: 'Hiq',
    back: 'Kthehu',
    clear: 'Pastro',
    language: 'Gjuha',
    pagination: { page: 'Faqja', of: 'nga', item: 'artikull', items: 'artikuj', total: 'gjithsej' },
    optional: 'opsionale',
    close: 'Mbyll',
    expand: 'Hap',
    collapse: 'Mbyll',
    confirm: 'Konfirmo',
    decline: 'Refuzo',
    accept: 'Prano',
    loading: 'Po ngarkohet…',
    noResults: 'Nuk u gjet asgjë.',
    noResultsHint: 'Përpiquni të ndryshoni filtrat ose kushtet e kërkimit',
    actions: 'Veprime',
    status: 'Statusi',
    active: 'Aktiv',
    inactive: 'Jo aktiv',
    yes: 'Po',
    no: 'Jo',
    search: 'Kërko…',
    filter: 'Filtro',
    all: 'Të gjitha',
    total: 'Total',
    notes: 'Shënime',
    name: 'Emri',
    email: 'Email',
    phone: 'Telefoni',
    address: 'Adresa',
    price: 'Çmimi',
    duration: 'Kohëzgjatja',
    category: 'Kategoria',
    description: 'Përshkrimi',
    dashboard: 'Paneli',
    settings: 'Cilësimet',
    profileLabel: 'Profili',
    today: 'Sot',
    tomorrow: 'Nesër',
    upcoming: 'Të ardhshme',
    past: 'Të kaluara',
    calMode: { day: 'Ditë', week: 'Javë', month: 'Muaj' },
    logout: 'Dil',
    trialBanner: {
        daysLeft: 'Provë falas — {{days}} ditë të mbetura',
        endsToday: 'Prova falas mbaron sot',
        endsOn: 'mbaron më {{date}}',
        upgrade: 'Duhet të paguani abonimin për të vazhduar',
    },
    // Shown to a shop's staff once its trial or plan has ended (PlanEnded.tsx)
    planEnded: {
        titleTrial: "Prova juaj falas ka përfunduar",
        titlePlan: "Plani juaj GetFade ka përfunduar",
        titleSuspended: "Ky lokal është pezulluar",
        dataSafe: "Takimet, klientët dhe berberët tuaj janë të gjithë të ruajtur. Asgjë nuk është fshirë.",
        off: "Paneli, aplikacioni për iPhone dhe faqja juaj e rezervimeve online janë të fikura për momentin.",
        renew: "Për të vazhduar me GetFade kushton €10 në muaj. Na shkruani dhe e riaktivizojmë lokalin tuaj.",
        renewSuspended: "Na shkruani dhe do t'ju ndihmojmë ta riktheni lokalin tuaj.",
        emailCta: "Na shkruani për të vazhduar",
        emailSubject: "Vazhdo me GetFade: {{shop}}",
        askOwner: "Kërkojini pronarit të lokalit ta rinovojë planin që të hyni përsëri.",
        signOut: "Dil",
        endedOn: "Përfundoi më {{date}}",
    },


    // Legal pages (Privacy / Terms / Security)
    legal: {
        updated: 'Përditësuar më',
        rights: 'Të gjitha të drejtat e rezervuara.',
        contact: {
            title: 'Na kontaktoni',
            body: 'Keni pyetje për këtë politikë? Na shkruani në getfade.io@gmail.com dhe do t\'ju përgjigjemi brenda pak ditësh pune.',
        },
        privacy: {
            title: "Politika e privatësisë",
            updated: "2 nëntor 2026",
            intro: "Kjo politikë shpjegon si i trajton të dhënat personale GetFade — faqja getfade.io dhe aplikacionet GetFade për iPhone, iPad dhe Android. GetFade drejtohet nga Ramadan Durguti, person fizik me seli në Kosovë (“ne”). Na kontaktoni në getfade.io@gmail.com.",
            sections: [
                { title: "Kush është përgjegjës", body: "Ne jemi përgjegjës për të dhënat e pronarëve dhe stafit të salloneve që përdorin GetFade. Për të dhënat e klientëve të një salloni (rezervimet, emrat, kontaktet) përgjegjës është salloni, ndërsa ne i përpunojmë në emër të tij, vetëm për t’i ofruar shërbimin. Klientët me pyetje për të dhënat e rezervimeve mund të kontaktojnë sallonin ose ne." },
                { title: "Çfarë të dhënash mbledhim", body: "Të dhënat e llogarisë: emri, adresa e email-it, fjalëkalimi (i ruajtur i hash-uar), identifikuesi i llogarisë, gjuha dhe fotoja opsionale e profilit. Të dhënat e sallonit: emri, adresa, logoja, orari, shërbimet, çmimet dhe anëtarët e ekipit. Të dhënat e rezervimeve të futura nga sallonet ose klientët e tyre: emrat e klientëve, numrat e telefonit, adresat e email-it, oraret, shërbimet dhe shënimet. Fotot dhe videot që zgjidhni të shtoni. Të dhëna teknike: adresa IP, lloji i shfletuesit dhe pajisjes, seancat e hyrjes, regjistrat e sigurisë dhe cookies. Tokenët e njoftimeve push, nëse i lejoni njoftimet në një aplikacion GetFade." },
                { title: "Sign in with Apple dhe Google", body: "Nëse përdorni Sign in with Apple, marrim emrin tuaj, adresën e email-it (që mund të jetë një adresë private relay e Apple) dhe një identifikues të llogarisë Apple. Nëse përdorni Continue with Google, në faqe ose në aplikacione, marrim emrin, adresën e email-it dhe një identifikues të llogarisë Google. I përdorim vetëm për të krijuar llogarinë dhe për t’ju kyçur." },
                { title: "Lejet e aplikacionit", body: "Aplikacionet GetFade kërkojnë qasje në kamerë vetëm kur zgjidhni të bëni një foto ose të skanoni një kod QR, dhe qasje në mikrofon vetëm kur zgjidhni të regjistroni një video. Qasja në bibliotekën e fotove përdoret vetëm për të ruajtur imazhet dhe skedarët që eksportoni, si kodet QR. Emri, adresa e email-it, numri i telefonit, fotot dhe videot, përmbajtja tjetër që shtoni dhe identifikuesi i llogarisë në aplikacione përdoren vetëm që aplikacionet të funksionojnë. Nuk ju gjurmojmë." },
                { title: "Si i përdorim dhe pse", body: "Për të ofruar shërbimin për të cilin jeni regjistruar: rezervimet online, kalendarët, kartelat e klientëve, raportet, konfirmimet dhe kujtuesit me email, si dhe njoftimet për rezervime në aplikacion dhe si njoftime push (përmbushja e kontratës). Për ta mbajtur GetFade të sigurt dhe për të parandaluar abuzimin, p.sh. mbrojtja nga botët në formularët publikë të rezervimit (interes i ligjshëm). Për përmbushjen e detyrimeve ligjore. Cookies opsionale përdoren vetëm me pëlqim. Nuk i shesim të dhënat personale dhe nuk i përdorim për reklama ose gjurmim ndër-aplikacionesh." },
                { title: "Ofruesit e shërbimeve", body: "I ndajmë të dhënat vetëm me ofruesit që na ndihmojnë të funksionojë GetFade, sipas kushteve për mbrojtjen e të dhënave: ofruesi ynë i hostimit në cloud (serverët dhe baza e të dhënave); Resend (dërgimi i email-eve); Cloudflare Turnstile (mbrojtja nga botët në formularët publikë të rezervimit); Apple (Sign in with Apple opsionale në aplikacione); Google (Continue with Google opsionale në faqe dhe në aplikacione, si dhe fontet e uebit); Apple Push Notification service dhe Google Firebase Cloud Messaging (dërgimi i njoftimeve push në aplikacionet për iPhone dhe Android). Mund t’i zbulojmë të dhënat edhe kur e kërkon ligji." },
                { title: "Transferimet ndërkombëtare", body: "Disa nga këta ofrues i përpunojnë të dhënat jashtë Kosovës dhe BE-së, për shembull në Shtetet e Bashkuara. Në këto raste mbështetemi në garancitë ligjore të ofruesit, si Klauzolat Standarde Kontraktuale të BE-së ose një vendim përshtatshmërie." },
                { title: "Sa kohë i ruajmë të dhënat", body: "Të dhënat e llogarisë dhe të sallonit ruhen sa kohë që llogaria është aktive. Kur e fshini llogarinë te Cilësimet → Siguria, ajo hiqet menjëherë; kur administratori i fundit i një salloni fshin llogarinë, fshihen edhe salloni dhe të dhënat e rezervimeve, bashkë me llogaritë e stafit që ekzistojnë vetëm për atë sallon. Kopjet në backup mbishkruhen brenda 30 ditëve. Regjistrat e sigurisë dhe seancat ruhen vetëm aq sa nevojitet për mbrojtjen e shërbimit. Tokenët push hiqen kur dilni nga aplikacioni ose e çinstaloni." },
                { title: "Të drejtat tuaja", body: "Mund t’i shihni, korrigjoni, eksportoni ose fshini të dhënat tuaja personale, të kundërshtoni përpunimin e bazuar në interes të ligjshëm dhe ta tërhiqni pëlqimin në çdo kohë. Shumicën e këtyre mund t’i bëni vetë te cilësimet e llogarisë; përndryshe na shkruani në getfade.io@gmail.com dhe do t’ju përgjigjemi brenda 30 ditëve. Keni gjithashtu të drejtë të ankoheni te Agjencia për Informim dhe Privatësi e Kosovës (AIP) ose te autoriteti për mbrojtjen e të dhënave në vendin tuaj." },
                { title: "Fëmijët", body: "GetFade nuk u drejtohet fëmijëve. Llogaritë e salloneve janë për persona 18 vjeç e lart. Klientët nën 16 vjeç duhet të rezervojnë me ndihmën e një prindi ose kujdestari." },
                { title: "Siguria", body: "Të dhënat enkriptohen gjatë transmetimit, fushat e ndjeshme enkriptohen në ruajtje dhe qasja është e kufizuar. Shihni faqen tonë të Sigurisë për detaje." },
                { title: "Cookies", body: "Përdorim cookies thelbësore për t’ju mbajtur të kyçur dhe për të mbajtur mend preferencat. Cookies opsionale vendosen vetëm pasi të pajtoheni në banerin e cookies. Detajet janë në Politikën e cookies." },
                { title: "Ndryshimet e kësaj politike", body: "Do ta përditësojmë këtë politikë kur ndryshon GetFade. Nëse ndryshimi është i rëndësishëm, do t’ju njoftojmë me email ose në aplikacion para se të hyjë në fuqi." },
            ],
        },
        support: {
            title: "Mbështetja e GetFade",
            updated: "2 nëntor 2026",
            intro: "Keni nevojë për ndihmë me llogarinë, terminet ose cilësimet e sallonit? Shkruani në <mail>getfade.io@gmail.com</mail>. Shënoni emrin e sallonit dhe përshkrimin e problemit. Mos e dërgoni kurrë fjalëkalimin.",
            signInTitle: "Hyrja në iPhone dhe iPad",
            signInBody: "Aplikacioni për iPhone dhe iPad mbështet email dhe fjalëkalim, Sign in with Apple dhe Continue with Google. E keni harruar fjalëkalimin, ose doni të shtoni një në llogarinë e krijuar me Apple ose Google? Zgjidhni <forgot>Keni harruar fjalëkalimin</forgot> dhe përdorni të njëjtën adresë email-i.",
            deleteTitle: "Fshirja e llogarisë",
            deleteBody: "Hapni Cilësimet, pastaj Siguria, pastaj Fshi llogarinë. Nëse llogaria ka fjalëkalim, shkruajeni së pari. Pastaj ju dërgojmë me email një kod me 6 shifra; shkruajeni për ta përfunduar. Llogaritë pa fjalëkalim (të krijuara me Apple ose Google) kanë nevojë vetëm për kodin. Llogaria hiqet menjëherë. Kur administratori i fundit i një salloni fshin llogarinë, fshihen edhe salloni dhe të dhënat e rezervimeve, bashkë me llogaritë e stafit që ekzistojnë vetëm për atë sallon. Ky veprim nuk mund të zhbëhet.",
            privacyTitle: "Privatësia",
            privacyBody: "Lexoni <privacy>Politikën e privatësisë</privacy> dhe <terms>Kushtet e shërbimit</terms>.",
        },
        terms: {
            title: "Kushtet e shërbimit",
            updated: "Tetor 2026",
            intro: "Këto kushte zbatohen për përdorimin e GetFade — faqja getfade.io dhe aplikacionet GetFade — të ofruar nga Ramadan Durguti, person fizik me seli në Kosovë (“ne”). Duke krijuar një llogari ose duke përdorur GetFade, ju pajtoheni me to. Kontakti: getfade.io@gmail.com.",
            sections: [
                { title: "Llogaria juaj", body: "Duhet të jeni të paktën 18 vjeç për të krijuar një llogari salloni. Mbajini të sigurta të dhënat e hyrjes; jeni përgjegjës për aktivitetin në llogarinë tuaj dhe për anëtarët e ekipit që ftoni." },
                { title: "Përdorimi i shërbimit", body: "Përdoreni GetFade për të drejtuar sallonin tuaj dhe për të menaxhuar rezervimet dhe klientët. Mos e përdorni për diçka të paligjshme, për spam ose për të ndërhyrë në shërbim apo te përdoruesit e tjerë." },
                { title: "Periudha falas dhe çmimi", body: "Sallonet e reja marrin 3 muaj falas me të gjitha veçoritë, pa nevojë për kartë pagese. Pas periudhës falas GetFade kushton €10 në muaj për sallon. Do t’ju kontaktojmë para se të mbarojë periudha falas për ta rregulluar pagesën drejtpërdrejt me ne; nuk ka blerje brenda aplikacioneve. Nëse nuk vazhdoni, mund ta pezullojmë sallonin derisa të ketë një plan aktiv. Çmimet janë në euro; çdo taksë e zbatueshme do të shfaqet në faturë." },
                { title: "Anulimi", body: "Mund ta ndalni planin në çdo kohë; ai përfundon në fund të muajit të paguar dhe nuk kthehen pagesa të pjesshme, përveç kur e kërkon ligji. Nëse e përdorni GetFade si konsumator e jo si biznes, i ruani të drejtat që ju jep ligji i detyrueshëm për konsumatorët." },
                { title: "Të dhënat tuaja dhe të klientëve tuaj", body: "Ju jeni pronar i të dhënave të biznesit, klientëve dhe rezervimeve që futni në GetFade. Jeni përgjegjës të keni bazë ligjore për të ndarë me ne të dhënat e klientëve tuaj. Ne i përpunojmë vetëm në emrin tuaj dhe siç përshkruhet në Politikën e privatësisë." },
                { title: "Disponueshmëria", body: "Punojmë që GetFade të jetë në dispozicion gjatë gjithë kohës, por nuk mund të garantojmë shërbim pa ndërprerje. Mirëmbajtjet e planifikuara i njoftojmë kur është e mundur." },
                { title: "Mbyllja e llogarisë", body: "Mund ta fshini llogarinë në çdo kohë te Cilësimet → Siguria. Nëse jeni administratori i fundit i një salloni, fshirja e llogarisë fshin edhe sallonin dhe të dhënat e tij. Mund të pezullojmë ose mbyllim llogaritë që i shkelin këto kushte, me njoftim kur është e arsyeshme." },
                { title: "Përgjegjësia", body: "GetFade ofrohet “siç është”. Për aq sa e lejon ligji, nuk jemi përgjegjës për humbje indirekte ose pasuese, dhe përgjegjësia jonë e përgjithshme kufizohet në tarifat që na keni paguar në 12 muajt para kërkesës. Asgjë në këto kushte nuk kufizon përgjegjësinë që nuk mund të kufizohet me ligj." },
                { title: "Ligji i zbatueshëm", body: "Këto kushte rregullohen nga ligjet e Republikës së Kosovës dhe mosmarrëveshjet zgjidhen nga gjykatat kompetente të Kosovës. Nëse jeni konsumator, ruani edhe mbrojtjen e ligjeve të detyrueshme të vendit ku jetoni." },
                { title: "Ndryshimet", body: "Mund t’i përditësojmë këto kushte ndërsa zhvillohet GetFade. Ndryshimet e rëndësishme do t’i njoftojmë me email ose në aplikacion të paktën 14 ditë para se të hyjnë në fuqi." },
            ],
        },
        security: {
            title: 'Siguria',
            updated: 'Prill 2026',
            intro: 'Mbrojtja e të dhënave të rruajtores tuaj është prioritet. Ja se si GetFade i mban të sigurta informacionet e klientëve dhe rezervimet.',
            sections: [
                { title: 'Enkriptimi', body: 'I gjithë trafiku midis pajisjeve tuaja dhe GetFade enkriptohet gjatë transmetimit me TLS 1.2+. Të dhënat e ndjeshme në ruajtje enkriptohen me AES-256.' },
                { title: 'Infrastruktura', body: 'GetFade funksionon në hosting cloud të menaxhuar, me lidhje të enkriptuara drejt bazës së të dhënave. Qasja në sistemet e prodhimit është e kufizuar vetëm te operatorët që e kanë të nevojshme.' },
                { title: 'Kontrolli i qasjes', body: 'Vetëm anëtarët që ftoni kanë qasje në të dhënat e rruajtores. Qasja e brendshme nga stafi i GetFade është rreptësisht e kufizuar, e regjistruar dhe përdoret vetëm për mbështetje ose nevoja operative.' },
                { title: 'Mbrojtja e të dhënave', body: 'Fushat e ndjeshme — numrat e telefonit dhe shënimet e klientëve, si dhe sekretet e autentikimit — enkriptohen në ruajtje në bazën e të dhënave, jo vetëm gjatë transmetimit. GetFade nuk përpunon pagesa me kartë dhe nuk trajton kurrë numra kartash.' },
                { title: 'Autentikimi', body: 'Fjalëkalimet ruhen të hash-uara me algoritme standarde të industrisë. Autentikimi me dy faktorë është i disponueshëm dhe rekomandohet për të gjithë pronarët e rruajtoreve.' },
                { title: 'Raportimi i dobësive', body: 'Gjetët një dobësi? Ju lutemi shkruani në getfade.io@gmail.com. Mirëpresim raportime në besim të mirë dhe përgjigjemi shpejt.' },
            ],
        },
    },

    // Days of week
    days: {
        monday: 'Hënë',
        tuesday: 'Martë',
        wednesday: 'Mërkurë',
        thursday: 'Enjte',
        friday: 'Premte',
        saturday: 'Shtunë',
        sunday: 'Diel',
    },

    daysShort: {
        monday: 'Hë',
        tuesday: 'Ma',
        wednesday: 'Më',
        thursday: 'En',
        friday: 'Pr',
        saturday: 'Sh',
        sunday: 'Di',
    },

    // Days of week (accusative case for "returns to" context)
    daysAccusative: {
        monday: 'të hënën',
        tuesday: 'të martën',
        wednesday: 'të mërkurën',
        thursday: 'të enjten',
        friday: 'të premten',
        saturday: 'të shtunën',
        sunday: 'të dielën',
    },

    // Months
    months: {
        january: 'Janar',
        february: 'Shkurt',
        march: 'Mars',
        april: 'Prill',
        may: 'Maj',
        june: 'Qershor',
        july: 'Korrik',
        august: 'Gusht',
        september: 'Shtator',
        october: 'Tetor',
        november: 'Nëntor',
        december: 'Dhjetor',
    },

    nav: {
        dashboard: 'Paneli',
        appointments: 'Terminet',
        customers: 'Klientët',
        barbers: 'Berberët',
        services: 'Shërbimet',
        haircuts: 'Prerje floku',
        products: 'Produktet',
        reports: 'Raportet',
        ads: 'Tregu',
        waitlist: 'Lista e pritjes',
        auditLogs: 'Regjistri i auditimit',
        workspace: 'Hapsira e punës',
        account: 'Llogaria',
        myProfile: 'Profili im',
        signOut: 'Dil',
        settings: 'Cilësimet',
        more: 'Më shumë',
        bookingLink: 'Faqja e rezervimit',
        copyBookingLink: 'Kopjo linkun e rezervimit',
        groupMain: 'Kryesore',
        groupManage: 'Menaxhim',
        groupInsights: 'Analiza',
        groupSettings: 'Cilësimet',
        dashboardDesc: 'Statistika & të ardhshmet',
        appointmentsDesc: 'Të gjitha rezervimet',
        history: 'Historiku',
        historyDesc: 'Terminet e kaluara & të përfunduara',
        customersDesc: 'Lista e klientëve',
        barbersDesc: 'Ekipi & oraret',
        timeoffDesc: 'Menaxho pushimet',
        servicesDesc: 'Prerje, rregullim & më shumë',
        haircutsDesc: 'Shto stilet e prerjes',
        productsDesc: 'Produkte & inventar',
        reportsDesc: 'Të ardhura & analiza',
        settingsDesc: 'Info dyqani & preferencat',
        myProfileDesc: 'Ndrysho të dhënat e llogarisë',
        signOutDesc: 'Mbyll sesionin',
        signOutConfirm: 'A jeni i sigurt që doni të dilni?',
    },

    dash: {
        todayAppointments: 'Terminet e sotme',
        totalCustomers: 'Klientët total',
        activeBarbers: 'Berber aktivë',
        activeServices: 'Shërbime aktive',
        revenueToday: 'Të ardhurat sot',
        pendingConfirmation: 'Në pritje të konfirmimit',
        completionRate: 'Shkalla e përfundimit',
        todayThroughput: 'Rezervime për sot',
        bookingsByHour: 'Rezervime sipas orës — të ardhura nga të përfunduarat',
        bookings: 'Rezervime',
        revenue: 'Të ardhura',
        upcomingAppointments: 'Terminet e ardhshme',
        recentActivity: 'Aktiviteti i fundit',
        noUpcoming: 'Nuk ka terminet të ardhshme.',
        noRecent: 'Nuk ka terminet të fundit.',
        lowStock: 'Paralajmërim stoku të ulët',
        viewProducts: 'Shiko produktet',
        dismiss: 'Mbyll',
        monthlyGoals: 'Objektivat mujore',
        setGoals: 'Vendos objektivat',
        editGoals: 'Ndrysho',
        noGoals: 'Nuk ka objektiva për këtë muaj.',
        setGoalsLink: 'Vendos objektivat',
        revenueGoal: 'Të ardhura',
        bookingsGoal: 'Rezervime',
        bookingsTrend: 'Tendenca e rezervimeve',
        last14: '14 ditët e fundit',
        shopView: 'Dyqani',
        mySchedule: 'Orari im',
        todaySchedule: 'Orari i sotëm',
        barberPerf: 'Performanca e berberëve',
        thisMonth: 'Këtë muaj',
        upcoming: 'Të ardhshme',
        nextScheduled: 'Terminet e ardhshme',
        viewAll: 'Shiko të gjitha',
        noToday: 'Nuk ka terminet sot',
        noBookingsToday: 'Asnjë rezervim sot',
        chartHint: 'Grafiku ndizet sapo të vijnë termine',
        noTodayHint: 'Terminet shfaqen këtu sapo rezervohen.',
        noMatches: 'Asnjë përputhje për filtrat tuaj',
        clearOrPress: 'Pastro kërkimin ose ndrysho filtrat. Shtyp',
        toCreateOne: 'për të krijuar një.',
        gettingStarted: 'Fillimi i punës',
        newAppointment: 'Cakto një termin të ri',
        noShowAbove: 'Mbi nivelin e shëndetshëm',
        noShowWithin: 'Brenda nivelit të shëndetshëm',
        noUpcomingFull: 'Nuk ka terminet të ardhshme',
        completed: 'të përfunduara',
        noShow: 'mungesë',
        noShows: 'mungesa',
        vsLastMonth: 'krahasuar me muajin e kaluar',
        thisWeek: 'këtë javë',
        topBarber: 'Berberi kryesor këtë javë',
        topService: 'Shërbimi kryesor:',
        repeatCustomers: 'Klientë të kthyer',
        noShowRate: 'Shkalla e mungesave',
        setMonthlyGoals: 'Vendos objektivat mujore',
        revenueTarget: 'Objektivi i të ardhurave (€)',
        bookingsTarget: 'Objektivi i rezervimeve',
        saveGoals: 'Ruaj objektivat',
        lowStockAlert: 'Paralajmërim stoku të ulët',
        appointmentSingular: 'termin',
        appointments: 'termin',
        appointmentsPlural: 'terminet',
        walkin: 'Pa rezervim',
        customize: 'Përshtatja e panelimit',
        kpiCards: 'Kartat KPI (Statistika të sotme)',
        weeklyInsights: 'Pasqyra javore',
        todaysSchedule: 'Orari i sotëm',
        upcomingAppointmentsList: 'Terminet e ardhshme',
        goodDay: 'Ditë të mirë',
        live: 'Drejtpërdrejt',
        unassigned: 'Paci',
        allClear: 'Të gjitha në rregull',
        filter: 'Filtro…',
        group: 'Grupi',
        groupBy: 'Grupi sipas',
        regulars: 'Klientë të rregullt',
        returningCustomers: 'Klientë të kthyer',
        allAppointments: 'Të gjitha',
        pendingAppointments: 'Në pritje',
        activeAppointments: 'Aktiv',
        completedAppointments: 'I përfunduar',
        confirmCount: 'Konfirmo {{count}}',
        firstAt: 'I pari në {{time}}',
        noBookingsYet: 'Nuk ka rezervime akoma',
        completedCount: 'të përfunduara',
        bookingsCount: 'rezervime',
    },
    common: {
        needsAction: 'Kërkon veprim',
    },
    appointmentStatus: {
        pending: 'Në pritje',
        confirmed: 'I konfirmuar',
        inProgress: 'Në vazhdim',
        completed: 'I përfunduar',
        cancelled: 'I anuluar',
        noShow: 'Nuk u paraqit',
        noShowThisWeek: 'mungesë këtë javë',
        today: 'Sot',
    },

    appt: {
        title: 'Terminet',
        history: 'Historiku',
        new: 'Termin i ri',
        newDesc: 'Plotëso të dhënat për të krijuar një termin të ri.',
        create: 'Krijo termin',
        edit: 'Ndrysho termin',
        barber: 'Berberi',
        customer: 'Klienti',
        service: 'Shërbimi',
        startsAt: 'Ora e fillimit',
        endsAt: 'Ora e mbarimit',
        status: 'Statusi',
        price: 'Çmimi',
        notes: 'Shënime',
        time: 'Ora',
        summary: 'Përmbledhje',
        stillNeed: 'Mungon',
        stepsDone: 'plotësuar',
        dateFilter: 'Periudha e datës',
        pending: 'Në pritje',
        confirmed: 'I konfirmuar',
        inProgress: 'Në vazhdim',
        completed: 'I përfunduar',
        cancelled: 'I anuluar',
        noShow: 'Nuk u paraqit',
        show: 'Shfaq',
        hide: 'Fsheh',
        cancelledBy: 'Anuluar nga',
        cancelledBy_customer: 'Anuluar nga klienti',
        cancelledBy_staff: 'Anuluar nga dyqani',
        openFull: 'Hap detajet e plota',
        bookingSource: 'Burimi i rezervimit',
        noAppointments: 'Nuk u gjetën termine.',
        noAppointmentsHint: 'Këto janë oraret e vetme të lira — të gjitha oraret e tjera janë tashmë të rezervuara.',
        cancelAppt: 'Anulo terminin',
        markComplete: 'Shëno si i përfunduar',
        markNoShow: 'Shëno si nuk u paraqit',
        selectBarberAndServiceFirst: 'Zgjidh berberin dhe shërbimin për të parë oraret e lira.',
        selectServiceFirst: 'Zgjidh një shërbim për të parë disponueshmërinë e berberëve.',
        checkingAvailability: 'Duke kontrolluar disponueshmërinë…',
        availableTimes: 'Oraret e lira',
        slotsAvailable: 'lirë',
        noSlotsOnDate: 'Nuk ka orare të lira këtë ditë — berberi është lirë ose plotësisht i zënë.',
        tryDifferentDate: 'Provo një datë tjetër.',
        tryDifferentDateOrBarber: 'Provo një datë ose berber tjetër.',
        doesntWorkThisDay: 'nuk punon këtë ditë.',
        nextWorkingDay: 'Dita tjetër e punës',
        clearDates: 'Pastro datat',
        allCaughtUp: 'Të gjitha të kryera!',
        closing: 'Po mbyllet…',
        bookingDetails: 'Detajet e rezervimit',
        bookingDetailsDesc: 'Plotëso informacionin për të caktuar një takim të ri.',
        searchCustomer: 'Kërko ose shkruaj emrin e klientit...',
        autoFilledHint: 'Berberi dhe shërbimi janë plotësuar nga vizita e fundit. Mund t\'i ndryshosh.',
        hidePast: 'Fsheh terminet e kaluara',
        showPast: 'Shfaq terminet e kaluara',
        selectTime: 'Zgjidh orën',
        editDesc: 'Ndrysho informacionin për të modifikuar këtë seancë.',
        assignedBarber: 'Berberi i caktuar',
        customerName: 'Emri i klientit',
        phoneNumber: 'Numri i telefonit',
        serviceType: 'Lloji i shërbimit',
        dateTime: 'Data dhe ora',
        internalNotes: 'Shënime të brendshme',
        notesPlaceholder: 'Alergji, preferencë, etj...',
        estimatedPrice: 'Çmimi i parashikuar:',
        repeat: 'Përsërit',
        doesNotRepeat: 'Nuk përsëritet',
        weekly: 'Çdo javë',
        biweekly: 'Çdo 2 javë',
        monthly: 'Çdo muaj',
        bookAppointment: 'Rezervo termin',
        updateAppointment: 'Përditëso terminin',
        tip: 'Bakshish (€)',
        recurringAppt: 'Ky është një termin i përsëritur',
        thisOnly: 'Vetëm ky termin',
        thisFuture: 'Ky dhe të gjithë të ardhshmet',
        selectBarber: 'Zgjidhni berberin',
        selectService: 'Zgjidhni shërbimin',
        selectDate: 'Zgjidhni datën',
        selectServices: 'Zgjidhni shërbimet',
        barberFreeToday: 'është i lirë sot',
        barberNotAvailableToday: 'nuk është i disponueshëm sot',
        review: 'Rishikimi',
        customerInfo: 'Informacioni i Klientit',
        pendingDesc: 'Në pritje të konfirmimit',
        clickToCreate: 'Kliko për të krijuar takimin',
        can: 'Mund',
        starts: 'Fillon',
        ends: 'Mbaron',
        apptStatus: 'Statusi i terminit',
        deleteAppt: 'Fshi Terminin',
        deleteConfirm: 'Jeni të sigurt që doni të fshini këtë termin? Ky veprim nuk mund të kthehet.',
        deleteThisOnly: 'Fshi vetëm këtë termin',
        deleteThisFuture: 'Fshi këtë dhe të gjitha të ardhshmet',
        myAppointments: 'Terminet e mia',
        allAppointments: 'Të gjitha terminet',
        mine: 'Të miat',
        exportCsv: 'Eksporto CSV',
        view: 'Shiko',
        walkIn: 'Pa rezervim',
        staff: 'Staf',
        newPendingBooking: 'Kërkesë e re rezervimi',
        riskHigh: 'Rrezik i lartë',
        riskMedium: 'I dyshimtë',
        riskFlag_no_phone: 'Nuk ka dhënë numër telefoni',
        riskFlag_new_customer: 'Klient i ri',
        riskFlag_has_no_show: 'Ka humbur takime më parë',
        riskFlag_frequent_no_show: 'Humbet takime shpesh',
        riskFlag_restricted_trust: 'Llogari e kufizuar',
        riskFlag_high_ip_activity: 'Shumë rezervime nga i njëjti pajisje',
        riskFlag_frequent_canceller: 'Anulon shpesh rezervime',
        riskFlag_recent_cancel: 'Ka anuluar një rezervim së fundmi',
        notFound: 'Termini Nuk u Gjet',
        notFoundTitle: 'Termini Nuk u Gjet',
        notFoundDesc: 'Ky termin mund të jetë fshirë ose nuk është më i disponueshëm. Kontrolloni listën e termineve për rezervimet aktuale.',
        backToList: 'Kthehu te Terminet',
        deletedBanner: 'Ky termin është fshirë dhe shfaqet vetëm për lexim.',
    },

    svc: {
        title: 'Shërbimet',
        new: 'Shërbim i ri',
        create: 'Krijo shërbim',
        edit: 'Ndrysho shërbim',
        serviceName: 'Emri i shërbimit',
        durationMin: 'Kohëzgjatja (minuta)',
        priceDollar: 'Çmimi (€)',
        colorLabel: 'Ngjyra',
        activeStatus: 'Statusi aktiv',
        activeDesc: 'Shërbimi do të jetë i dukshëm për rezervim menjëherë.',
        activeEditDesc: 'Lejo klientët të shikojnë dhe rezervojnë këtë shërbim.',
        serviceDesc: 'Përshkrimi i shërbimit',
        newDesc: 'Përcaktoni një ofertë të re për dyqanin tuaj, duke përfshirë kohëzgjatjen dhe çmimet.',
        editDesc: 'Përditëso detajet dhe çmimet për këtë shërbim.',
        updateService: 'Përditëso shërbimin',
        uncategorized: 'Pa kategori',
        clearColor: 'Pastro',
        descPlaceholder: 'Jepni detaje rreth asaj që përfshin ky shërbim…',
        deleteConfirm: 'Jeni të sigurt që doni të fshini këtë shërbim? Ky veprim nuk mund të kthehet.',
        serviceNamePlaceholder: 'p.sh. Prerje klasike',
        categoryPlaceholder: 'p.sh. Prerje floku',
        noServices: 'Nuk ka shërbime ende.',
        created: 'Shërbimi u krijua.',
        updated: 'Shërbimi u përditësua.',
        deleted: 'Shërbimi u fshi.',
    },

    hair: {
        title: 'Prerje floku',
        new: 'Prerje floku e re',
        create: 'Krijo prerje floku',
        edit: 'Ndrysho prerje floku',
        editDesc: 'Përditëso detajet e prerjes',
        createNew: 'Krijo prerje floku të re',
        addCustom: 'Shto një stil të personalizuar të prerjes për dyqanin tuaj',
        image: 'Imazhi',
        uploadImage: 'Ngarko imazh',
        imagePlaceholder: 'PNG, JPG deri 5MB',
        name: 'Emri',
        namePlaceholder: 'p.sh. Prerja klasike GetFade',
        description: 'Përshkrim i shkurtër',
        descPlaceholder: 'p.sh. Timeless dhe i pastër',
        detailedDesc: 'Përshkrim i detajuar',
        detailedDescPlaceholder: 'Përshkrim i plotë për gjenerimin e imazheve AI (opsionale)',
        active: 'Aktiv',
        activeDesc: 'Shfaq këtë prerje floku për klientët',
        createBtn: 'Krijo prerje floku',
        updateBtn: 'Përditëso prerje floku',
        creating: 'Po krijohet...',
        noHaircuts: 'Nuk ka prerje floku ende.',
        deleteConfirm: 'Jeni të sigurt që doni të fshini këtë prerje floku?',
        deleted: 'Prerja e flokut u fshi.',
        created: 'Prerja e flokut u krijua.',
        updated: 'Prerja e flokut u përditësua.',
    },

    barber: {
        title: 'Berberët',
        new: 'Berber i ri',
        create: 'Krijo berber',
        edit: 'Ndrysho berberin',
        info: 'Informacioni',
        specialty: 'Specialiteti',
        rating: 'Vlerësimi',
        totalReviews: 'Totali i vlerësimeve',
        noBarbers: 'Nuk ka berberë ende.',
        schedule: 'Orari',
        workingHours: 'Orët e punës',
        weeklyWorkingHours: 'Orët e punës në javë',
        scheduleDescription: 'Ndizni/zbritni ditët dhe vendosni orë fillestar dhe përfundimi. Takimet mund të booken vetëm gjatë orëve aktive.',
        dayOff: 'Dita e lirë',
        to: 'deri',
        applyToWeekdays: 'Apliko të hënë–të premte',
        saveSchedule: 'Ruaj orarin',
        maxClosingHour: 'Ora maksimale e mbylljes',
        maxClosingHourDesc: 'Vendosni kohën më të vonë kur berberat mund të mbyllin ditën. Kjo kufizon orët e disponueshme të mbylljes në planifikimin e termave.',
        googleCalendar: 'Google Kalendari',
        connected: 'I lidhur',
        notConnected: 'Jo i lidhur',
        connect: 'Lidh',
        disconnect: 'Shkëput',
        googleCalendarDesc: "Sinkronizo takimet me Google Kalendarin e këtij berberi.",
        fullName: 'Emri i plotë',
        emailAddress: 'Adresa e emailit',
        initialPassword: 'Fjalëkalimi fillestar',
        specialtyExpertise: 'Specialitet / Ekspertizë',
        calendarColor: 'Ngjyra e kalendarit',
        color: 'Ngjyra',
        professionalBio: 'Bio profesionale',
        bio: 'Bio',
        bioPlaceholder: 'Shkruaj një bio të shkurtër...',
        activeSchedule: 'Orari aktiv',
        activeScheduleDesc: 'Ndryshoni nëse ky berber është i disponueshëm për rezervim.',
        createDescription: 'Shto një berber të ri në ekipin tuaj.',
        newDesc: 'Krijo një profil të ri profesional dhe kredenciale hyrjeje për berberin.',
        editDesc: 'Modifiko detajet e profilit, informacionin e kontaktit dhe statusin.',
        updateBarber: 'Përditëso berberin',
        you: 'Ti',
        generalist: 'Gjeneralist',
        offToday: 'Lirë sot',
        returnsTo: 'Kthehet',
        markAvailable: 'Shëno i disponueshëm sot',
        markUnavailable: 'Shëno i padisponueshëm sot',
        deleteConfirm: 'Jeni të sigurt që doni të hiqni këtë berber? Kjo do të ndikojë në disponueshmërinë dhe orarin e tyre të ardhshëm.',
        namePlaceholder: 'p.sh. Arben Gashi',
        emailPlaceholder: 'berber@shembull.com',
        passwordPlaceholder: '••••••••',
        specialtyPlaceholder: 'p.sh. Formësim mjekrë',
    },

    cust: {
        title: 'Klientët',
        new: 'Klient i ri',
        create: 'Krijo klient',
        edit: 'Ndrysho klientin',
        addCustomer: 'Shto klient',
        editCustomer: 'Ndrysho klientin',
        deleteCustomer: 'Fshi klientin',
        deleteConfirm: 'Jeni i sigurt? Klienti do të fshihet.',
        name: 'Emri',
        phone: 'Telefoni',
        email: 'Email',
        address: 'Adresa',
        notes: 'Shënime',
        visits: 'Vizita',
        noShows: 'Mungesa',
        cancellations: 'Anulime',
        byStaff: 'nga stafi',
        byCustomer: 'nga klienti',
        loyalty: 'Besnikëria',
        trust: 'Besimi',
        loyaltyPoints: 'Pikë besnikërie',
        lastVisit: 'Vizita e fundit',
        favoriteBarber: 'Berberi i preferuar',
        noCustomers: 'Nuk ka klientë ende.',
        noCustomersDesc: 'Klientët shtohen automatikisht kur rezervojnë, ose mund t\'i shtoni manualisht.',
        noCustomersYet: 'Ende pa klientë',
        trustOk: 'I besuar',
        trustRestricted: 'I kufizuar',
        trustBlocked: 'I bllokuar',
        searchPlaceholder: 'Kërko...',
        namePlaceholder: 'p.sh. Arben Gashi',
        phonePlaceholder: '+383 49 000 000',
        noResults: 'Nuk u gjet asnjë klient.',
        addNew: 'Shto klient të ri',
        quickCode: 'Kodi',
        hasNoShows: 'Ka mungesa',
        noNoShows: 'Pa mungesa',
        clearFilters: 'Pastro filtrat',
        sortBy: 'Rendit sipas',
        sortByVisits: 'Rendit sipas vizitave',
        mostVisits: 'Më shumë vizita',
        leastVisits: 'Më pak vizita',
        mostNoShows: 'Më shumë mungesa',
        leastNoShows: 'Më pak mungesa',
        defaultSort: 'Default',
        resetPassword: 'Përcakto fjalëkalim të ri',
        resetPasswordTitle: 'Përcakto fjalëkalim të ri',
        resetPasswordDesc: 'Vendosni një fjalëkalim të ri për {{name}}. Sigurohuni që ta ndarni në mënyrë të sigurt.',
        newPassword: 'Fjalëkalim i ri',
        confirmPassword: 'Konfirmo fjalëkalimin',
        savePassword: 'Ruaj fjalëkalimin',
    },

    prod: {
        title: 'Produktet',
        new: 'Produkt i ri',
        create: 'Krijo produkt',
        edit: 'Ndrysho produktin',
        stock: 'Stoku',
        lowStock: 'Stok i ulët',
        noProducts: 'Nuk ka produkte ende.',
        stockQty: 'Sasia në stok',
        lowStockThreshold: 'Kufiri i stokut të ulët',
        lowStockAlert: 'Alarmi i stokut të ulët',
        lowStockHint: 'Shfaq shenjë paralajmëruese kur stoku bie deri ose poshtë këtij numri.',
        productName: 'Emri i produktit',
        activeStatus: 'Statusi aktiv',
        activeDesc: 'Produkti do të jetë i disponueshëm për t\'u shtuar në takime.',
        newDesc: 'Shto një produkt tregtar në inventarin tuaj për shitje në takime.',
        editDesc: 'Përditëso detajet dhe nivelet e stokut për këtë produkt.',
        updateProduct: 'Përditëso produktin',
        uncategorized: 'Pa kategori',
        priceDollar: 'Çmimi (€)',
        stockQuantity: 'Sasia në stok',
        deleteConfirm: 'Jeni të sigurt që doni të fshini këtë produkt? Ky veprim nuk mund të kthehet.',
        namePlaceholder: 'p.sh. Pomadë',
        categoryPlaceholder: 'p.sh. Kujdesi i flokëve',
        image: 'Foto e produktit',
        imageDesc: 'JPG, PNG ose WebP, maks. 2MB.',
        imageInvalidType: 'Lejohen vetëm fotografi JPG, PNG ose WebP.',
        imageTooLarge: 'Fotografia është {{size}} MB. Madhësia maksimale është 2 MB.',
        uploadImage: 'Ngarko foton',
        changeImage: 'Ndrysho foton',
        addCategory: 'Shto kategori të re',
        category: 'Kategoria',
        categoryNone: 'Pa kategori',
        costPrice: 'Çmimi i kostos',
        costPriceHint: 'Sa paguani furnizuesin (përdoret për raportin e marzhit).',
        description: 'Përshkrim i shkurtër',
        descriptionPlaceholder: 'Shënime opsionale që shfaqen në faqen e produktit.',
        history: 'Historiku',
        historyEmpty: 'Nuk ka ende lëvizje stoku.',
        manageCategories: 'Menaxho kategoritë',
        margin: 'Marzhi',
        sku: 'SKU',
        skuHint: 'Identifikues unik i produktit ose kodi me shirita.',
        skuPlaceholder: 'p.sh. POM-001',
        movement: {
            sale: 'Shitje',
            refund: 'Rimbursim',
            adjustment: 'Rregullim',
            restock: 'Rimbushje',
            initial: 'Stoku fillestar',
        },
    },

    profile: {
        title: 'Cilësimet e llogarisë',
        general: 'Të përgjithshme',
        security: 'Siguria',
        sessions: 'Seancat',
        dangerZone: 'Zona e rrezikshme',
        bookingLink: 'Lidhja juaj e rezervimit',
        bookingLinkDesc: 'Ndani këtë lidhje me klientët tuaj',
        copy: 'Kopjo',
        copied: 'U kopjua!',
        deleteAccount: 'Fshi llogarinë',
        profileInfo: 'Informacioni i profilit',
        profileInfoDesc: 'Përditëso emrin dhe adresën e e-mailit të llogarisë tuaj.',
        changePhoto: 'Ndrysho foton',
        removePhoto: 'Hiq foton',
        saveChanges: 'Ruaj ndryshimet',
        saved: 'U ruajt.',
        emailUnverified: 'E-maili juaj nuk është i verifikuar.',
        resendEmail: 'Dërgo sërish email verifikimi.',
        verificationSent: 'Një lidhje e re verifikimi ka qenë dërguar.',
    },

    booking: {
        title: 'Rezervo',
        languagePreference: 'Gjuha',
        resendingCode: 'Po ridërgohet…',
        confirmation: {
            title: 'Rezervimi u konfirmua',
        },
        nav: {
            book: 'Rezervo',
            appointments: 'Rezervimet e mia',
            profile: 'Profili',
        },
        chooseBarber: 'Zgjidhni berberin',
        chooseServices: 'Zgjidhni shërbimet',
        noServices: 'Nuk ka shërbime',
        noServicesDesc: 'Dyqani nuk ka shtuar shërbime ende.',
        pickDateTime: 'Zgjidhni datën dhe orën',
        yourDetails: 'Të dhënat tuaja',
        errorNameRequired: 'Ju lutemi shkruani emrin tuaj të plotë.',
        errorPhoneRequired: 'Ju lutemi shkruani numrin tuaj të telefonit.',
        bookingSummary: 'Përmbledhja e rezervimit',
        yourName: 'Emri juaj i plotë',
        yourPhone: 'Numri i telefonit',
        specialRequests: 'Kërkesa të veçanta?',
        confirmBooking: 'Konfirmo rezervimin',
        privacyNotice: 'Të dhënat tuaja i shkojnë {{shop}} për të menaxhuar terminin dhe ruhen në mënyrë të sigurt nga GetFade. <privacy>Politika e privatësisë</privacy>',
        booking: 'Po rezervon…',
        namePlaceholder: 'Emri juaj i plotë',
        phonePlaceholder: '+355 6X XXX XXXX',
        emailPlaceholder: 'emaili@juaj.com',
        barber: 'Berber',
        date: 'Data',
        time: 'Ora',
        loadingSlots: 'Po ngarkohen oraret…',
        noSlots: 'Nuk ka orare të lira këtë ditë. Provoni një datë tjetër.',
        barberNotWorking: 'Ky berber nuk punon këtë ditë. Ju lutemi zgjidhni një datë tjetër.',
        barberOnTimeOff: 'Ky berber është në pushim këtë ditë. Ju lutemi zgjidhni një datë tjetër.',
        loadingAvailability: 'Po ngarkohet disponueshmëria…',
        noSlotsBadge: 'Pa orare',
        continue: 'Vazhdo',
        anyBarber: 'Çdo berber i disponueshëm',
        anyBarberDesc: 'Orari i parë i lirë mes të gjithë berberëve',
        anyBarberFastest: 'Më i shpejtë',
        anyBarberAutoAssign: 'Berberi më i lirë do të caktohet automatikisht kur të zgjidhni orarin.',
        morning: 'Mëngjes',
        afternoon: 'Pasdite',
        evening: 'Mbrëmje',
        services: 'Shërbime',
        service: 'Shërbim',
        min: 'min',
        totalPrice: 'Çmimi total',
        with: 'me',
        tryingStyle: 'Po provoj këtë stil',
        bookYourVisit: 'Rezervo vizitën tënde.',
        heroSubtitle: 'Zgjidh çfarë të nevojitet, kë të besosh dhe kur. Mjaftojnë vetëm një minutë.',
        selectedCount: 'të zgjedhura',
        duration: 'Kohëzgjatja',
        step: {
            barber: 'Berberi',
            service: 'Shërbimi',
            dateTime: 'Data & Ora',
            info: 'Të dhënat',
        },
        confirmed: 'Rezervimi u konfirmua!',
        confirmedDesc: 'Gjithçka është gati. Ju presim!',
        pending: 'Takimi u mor',
        pendingDesc: 'Takimi juaj pret konfirmim. Do t\'ju kontaktojmë shpejt.',
        appointmentDetails: 'Detajet e takimit',
        cancelWindow: 'Dëshironi të anuloni? Keni',
        graceWindow: 'Ndryshuat mendje? Mund të anuloni brenda',
        cancelAppt: 'Anulo takimin',
        cancelledTitle: 'Takimi u anulua',
        cancelledDesc: 'Takimi juaj u anulua. Shpresojmë t\'ju shohim herën tjetër.',
        unavailableTitle: "{{shop}} nuk pranon rezervime online për momentin",
        unavailableDesc: "Ju lutemi kontaktoni lokalin drejtpërdrejt për të rezervuar.",
        yourBookings: "Rezervimet tuaja",
        viewOrCancel: "Shiko ose anulo",
        bookAnother: 'Rezervo një termin të ri',
        shopPhone: 'Telefoni i dyqanit',
        getDirections: 'Lokacioni',
        windowExpired: 'Dritarja e anulimit ka skaduar.',
        viewMyAppts: 'Shiko terminet e mia',
        errorInvalidPhone: 'Ju lutem futni një numër telefoni të vlefshëm (7-15 shifra ose +1-15 shifra)',
        checkStatus: 'Kontrolloni Statusin e Rezervimit',
        statusTitle: 'Statusi i Rezervimit',
        statusPending: 'Duke Pritur Konfirmimin',
        statusPendingDesc: 'Dyqani do të konfirmojë termin tuaj së shpejti.',
        statusBadgePending: 'Duke Pritur',
        pendingHint: 'Kthehuni në disa minuta për të kontrolluar nëse termini juaj është miratuar. Statusi do të përditësohet automatikisht.',
        bookAgain: 'Rezervo përsëri',
        products: 'Produktet',
        noProductsYet: 'Nuk ka produkte ende.',
        outOfStock: 'Pa stok',
        addToCalendar: 'Shto në Kalendar',
        directions: 'Drejtimet',
        callShop: 'Telefono',
        cancelAppointment: 'Anulo terminin',
        cancelConfirmTitle: 'Anulo terminin?',
        cancelConfirm: 'A jeni i sigurt që dëshironi të anuloni këtë termin? Ky veprim nuk mund të ndryshohej.',
        cancelKeep: 'Mbaje terminin',
        confirmCancel: 'Anulo terminin',
        cancelling: 'Po anulohet…',
        appointmentCancelled: 'Termini u anulua me sukses',
        appointmentCancelFailed: 'Dështoi anulimi i termini',
        myProfile: 'Profili im',
        profileTitle: 'Profili im',
        profileInfo: 'Të dhënat e mia',
        profileInfoDesc: 'Përditëso emrin, email-in dhe adresën tënde.',
        fullName: 'Emri i plotë',
        emailLabel: 'Email',
        phoneLabel: 'Telefoni',
        phoneLocked: 'Telefoni nuk mund të ndryshohet',
        addressLabel: 'Adresa',
        save: 'Ruaj',
        saved: 'Ndryshimet u ruajtën.',
        passwordSection: 'Fjalëkalimi',
        passwordSectionDesc: 'Mbaje llogarinë tënde të sigurt me një fjalëkalim të fortë.',
        deleteAccount: 'Fshij llogarinë time',
        deleteAccountDesc: 'Heq emrin, kontaktet dhe hyrjen tënde për {{shop}} dhe anulon rezervimet e ardhshme. Vizitat e kaluara mbeten në regjistrat e sallonit pa të dhënat e tua.',
        deleteAccountConfirm: 'Kjo nuk mund të kthehet.',
        deleteAccountButton: 'Fshij llogarinë',
        deleteAccountButtonConfirm: 'Po, fshij llogarinë time',
        deleteAccountSendCode: 'Më dërgo një kod',
        deleteAccountCodeSent: 'Të dërguam një kod 6-shifror në {{email}}. Shkruaje për ta fshirë llogarinë.',
        deleteAccountCodeLabel: 'Kodi nga email-i',
        deleteAccountResend: 'Dërgo një kod të ri',
        accountDeleted: 'Llogaria jote u fshi.',
        languageTitle: 'Gjuha e preferuar',
        languageDesc: 'Do ta shfaqim këtë dyqan në gjuhën që zgjedh. Mbizotëron mbi zgjedhjen e dyqanit.',
        languageNotSet: 'Nuk është vendosur - do të përdoret standard i dyqanit',
        languageActive: 'Aktiv',
        changePassword: 'Ndrysho fjalëkalimin',
        setPassword: 'Vendos fjalëkalimin',
        currentPassword: 'Fjalëkalimi aktual',
        newPassword: 'Fjalëkalimi i ri',
        confirmPassword: 'Konfirmo fjalëkalimin',
        passwordUpdated: 'Fjalëkalimi u përditësua.',
        uploadPhoto: 'Ngarko foton',
        changePhoto: 'Ndrysho foton',
        stillNeed: 'Të nevojshme:',
        statusConfirmed: 'Termini juaj është Konfirmuar!',
        statusConfirmedDesc: 'Termini juaj është konfirmuar. Presim me ardhjen tuaj.',
        statusBadgeConfirmed: 'Konfirmuar',
        statusInProgress: 'Termini juaj po ecën',
        statusInProgressDesc: 'Termini juaj po shërbëhet aktualisht.',
        statusBadgeInProgress: 'Po ecën',
        statusCompleted: 'Termin i Përfunduar',
        statusCompletedDesc: 'Faleminderit për vizitën tuaj!',
        statusBadgeCompleted: 'Përfunduar',
        statusCancelled: 'Termin i Anuluar',
        statusCancelledDesc: 'Ky termin u anulua.',
        statusBadgeCancelled: 'Anuluar',
        statusNoShow: 'Mungesë',
        statusNoShowDesc: 'Ju nuk u shfaqët për këtë termin.',
        statusBadgeNoShow: 'Mungesë',
        trackBooking: 'Ju mund ta kontrolloni statusin e rezervimit në çdo kohë:',
        createAccount: 'Krijo një Llogari',
        createAccountDesc: 'Vendosni të dhënat tuaja për të rezervuar një termin. Do t\'ju verifikojmë emailin.',
        firstName: 'Emri',
        firstNamePlaceholder: 'Filan',
        lastName: 'Mbiemri',
        lastNamePlaceholder: 'Fisteku',
        sendingCode: 'Duke dërguar kodin…',
        verifyEmail: 'Verifiko Email-in',
        verifyEmailDesc: 'Kemi dërguar një kod 4-shifror në {{email}}',
        verificationCode: 'Kodi i Verifikimit',
        verifying: 'Duke verifikuar…',
        verifyAndBook: 'Verifiko & Vazhdo me Rezervimin',
        didntReceiveCode: 'Nuk e morët kodin?',
        resendCode: 'Ridërgo Kodin',
        codeSent: 'Një kod i ri u dërgua!',
        switchAccount: 'Ndrysho llogarinë',
        newAccount: 'Llogari e Re',
        haveCode: 'Kam një Kod',
        quickLogin: 'Hyrje e Shpejtë',
        quickLoginDesc: 'Vendosni kodin 4-shifror që morët nga dyqani.',
        clientCode: 'Kodi i Klientit',
        loggingIn: 'Duke hyrë...',
        loginAndBook: 'Hyr & Rezervo',
        myAppointments: 'Terminet e Mia',
        upcomingAppointments: 'Të ardhshme',
        pastAppointments: 'Të kaluara',
        noUpcoming: 'Nuk ka termine të ardhshme.',
        noPast: 'Nuk ka termine të kaluara.',
        loadMore: 'Shfaq më shumë',
        bookNow: 'Rezervo Tani',
    },

    // Time Off
    timeoff: {
        title: 'Pushimet',
        deleteTitle: 'Fshi Pushimin',
        manage: 'Administro mungesën dhe pushimin',
        add: 'Shto kohë të lirë',
        noTimeOff: 'Nuk ka kohë të lirë të planifikuar.',
        upcomingActive: 'E ardhshme & Aktive',
        from: 'Nga',
        to: 'Deri',
        reason: 'Arsyeja (opsionale)',
        reasonPlaceholder: 'p.sh. Pushime, sëmundje…',
    },

    // Walk-in modal
    walkin: {
        title: 'Rezervim i shpejtë pa takim',
        customerName: 'Emri i Klientit',
        namePlaceholder: 'p.sh. Arben Gashi',
        service: 'Shërbimi',
        selectService: 'Zgjidhni shërbimin',
        barber: 'Berberi',
        selectBarber: 'Zgjidhni berberin',
        bookNow: 'Rezervo Tani',
        button: 'Pa rezervim',
        collapse: 'Mbyll',
        noBarbers: 'Nuk ka berberë në dispozicion për këtë shërbim tani',
        noServices: 'Nuk ka shërbime në dispozicion',
        noServicesDesc: 'Shtoni shërbime më parë.',
    },

    pending_requests: {
        title: '1 kërkesë në pritje',
        description: 'Prekni për të konfirmuar ose refuzuar secilin',
        confirmButton: 'Konfirmo',
        declineButton: 'Refuzo',
        cancelAppointment: 'Anulo terminin',
        cancelAppointmentTitle: 'Anulo terminin?',
        cancelAppointmentDesc: 'Klienti do të njoftohet dhe slot-i do të lirohet. Vazhdo?',
        cancelAppointmentConfirm: 'Po, anulo',
        cancelAppointmentAbort: 'Jo, mbaje',
        cancelledByShop: 'Anuluar nga dyqani',
        bannerOne: '{{count}} rezervim në pritje për konfirmim',
        bannerOther: '{{count}} rezervime në pritje për konfirmim',
        review: 'Shqyrto',
        modalTitleOne: '{{count}} kërkesë në pritje',
        modalTitleOther: '{{count}} kërkesa në pritje',
    },

    // Appointment Show page
    show: {
        overview: 'Përmbledhje',
        products: 'Produktet',
        customerInfo: 'Informacioni i Klientit',
        review: 'Vlerësimi',
        rating: 'Nota',
        comment: 'Koment',
        serviceDetails: 'Detajet e Shërbimit',
        tip: 'Bakshish',
        payment: 'Pagesa',
        appointmentNotes: 'Shënime të Terminit',
        barberNotes: 'Shënime të Berberit',
        noNotes: 'Nuk ka shënime për këtë termin.',
        productsSold: 'Produkte të Shitura',
        add: 'Shto',
        product: 'Produkti',
        selectProduct: 'Zgjidhni produktin…',
        outOfStock: '— i mbaruar',
        inStock: 'në stok',
        qty: 'Sasia',
        addProduct: 'Shto Produkt',
        noProducts: 'Nuk ka produkte të shtuara në këtë termin.',
        min: 'min',
        newBookingRequest: 'Kërkesë e re rezervimi',
        newBookingRequestSub: 'Ky termin pret konfirmimin tuaj.',
    },

    dm: {
        bookingLink: 'Linku i Rezervimit',
        bookingLinkDesc: 'Ndani këtë link me klientët.',
        copyLink: 'Kopjo Linkun',
        copied: 'U kopjua!',
        dmTemplates: 'Shabllone të Shpejta',
        template1: 'Rezervo takimin tënd këtu 👇\n{url}',
        template2: 'Zgjedh orarin tënd këtu 👇\n{url}',
        copy1: 'Kopjo Shabllon 1',
        copy2: 'Kopjo Shabllon 2',
    },

    auth: {
        signIn: 'Hyr',
        signInTitle: 'Hyrje | GetFade',
        signInHeading: 'Hyrje',
        signInSub: 'Fut të dhënat tuaja për të hyrë në panel.',
        signInButton: 'Hyr',
        signingIn: 'Po hyn...',
        noAccount: 'Nuk keni llogari?',
        createOne: 'Krijo një',
        keepSignedIn: 'Mbaj mua të kyçur',
        forgot: 'Harruat?',
        welcomeBack: 'Mirë se',
        welcomeBackAccent: 'u kthyet.',
        welcomeBackSub: 'Menaxhoni dyqanin, terminet dhe ekipin — në një vend.',
        testimonialLogin: 'Kursen orë çdo javë. Klientët e mi e duan rezervimin online.',
        shopOwner: '— Pronar dyqani',
        statFree: 'Falas për 3 muaj',
        statNoCard: 'Pa kartë krediti',
        secureLogin: 'Hyrje e sigurt',
        register: 'Krijo Dyqanin | GetFade',
        registerHeading: 'Krijo dyqanin tuaj',
        registerSub: 'Plotëso të dhënat për të filluar falas.',
        registerButton: 'Krijo Dyqanin',
        creatingShop: 'Po krijon dyqanin...',
        alreadyAccount: 'Keni llogari?',
        signInLink: 'Hyr',
        signUp: 'Regjistrohu',
        shopName: 'Emri i Dyqanit',
        yourName: 'Emri Juaj',
        phone: 'Telefoni',
        password: 'Fjalëkalimi',
        confirmPassword: 'Konfirmo',
        emailPlaceholder: 'ti@shembull.com',
        shopNamePlaceholder: 'Berber Elite',
        yourNamePlaceholder: 'Arben Gashi',
        secureRegistration: 'Regjistrim i sigurt',
        or: 'ose',
        googleSignUp: 'Regjistrohu me Google',
        googleSignIn: 'Hyr me Google',
        appleContinue: 'Vazhdo me Apple',
        appleConnected: 'I lidhur me Apple',
        googleConnected: 'I lidhur me Google',
        terms: 'Duke krijuar një dyqan, ti pranon <terms>Kushtet</terms> dhe <privacy>Politikën e Privatësisë</privacy>.',
        setUpShop: 'Konfiguro',
        setUpShopAccent: 'dyqanin.',
        setUpShopSub: 'Krijo llogarinë dhe fillo të pranosh rezervime brenda minutave.',
        testimonialRegister: 'U konfigurua brenda 5 minutave, plotësisht funksional brenda ditës.',
        forgotTitle: 'Fjalëkalim i Harruar | GetFade',
        forgotHeading: 'Keni harruar fjalëkalimin?',
        forgotSub: 'Futni emailin tuaj dhe do t\'ju dërgojmë një link rivendosjeje.',
        forgotButton: 'Dërgo Linkun e Rivendosjes',
        sendingReset: 'Po dërgohet...',
        backToLogin: 'Kthehu te hyrja',
        resetTitle: 'Rivendos Fjalëkalimin | GetFade',
        resetHeading: 'Rivendos fjalëkalimin',
        resetSub: 'Ju lutemi zgjidhni një fjalëkalim të fortë dhe unik.',
        resetButton: 'Përditëso Fjalëkalimin',
        updatingPassword: 'Po përditësohet...',
        accountEmail: 'Email i Llogarisë',
        newPassword: 'Fjalëkalim i Ri',
        confirmNewPassword: 'Konfirmo Fjalëkalimin e Ri',
        remembered: 'E kujtuat?',
        verifyTitle: 'Verifiko Emailin | GetFade',
        verifyHeading: 'Verifiko emailin tuaj',
        verifySub: 'Faleminderit që u regjistruat! Klikoni linkun që dërguam në kutinë tuaj postare.',
        verifyButton: 'Ridërgo Emailin e Verifikimit',
        sendingVerify: 'Po dërgohet...',
        verificationSent: 'Një link i ri u dërgua në adresën tuaj.',
        verificationCheckEmail: 'Kontrolloni emailin tuaj',
        verificationCheckEmailSub: 'Dërguam një kod verifikimi në adresën tuaj.',
        verificationCodeSent: 'Një kod verifikimi i ri u dërgua në emailin tuaj. Ai do të skadojë në 10 minuta.',
        verificationCode: 'Kodi i Verifikimit',
        verifyCode: 'Verifiko Kodin',
        verifyingCode: 'Po verifikohet...',
        resendCode: 'Ridërgo Kodin',
        verificationSuccess: 'Email i Verifikuar!',
        verificationSuccessSub: 'Emaili juaj u verifikua me sukses. Tani mund të hyrni në platformën e plotë.',
        goToDashboard: 'Shko te Paneli',
        notYourEmail: 'Jo emailin tuaj?',
        wrongEmail: 'Email i gabuar?',
        goBack: 'Kthehu mbrapa',
        logOut: 'Dil',
        confirmTitle: 'Konfirmo Aksesin | GetFade',
        confirmHeading: 'Kërkohet fjalëkalimi',
        confirmSub: 'Ju lutemi konfirmoni fjalëkalimin tuaj para se të vazhdoni.',
        confirmButton: 'Konfirmo Aksesin',
        verifying: 'Po verifikohet...',
        notYou: 'Nuk jeni ju?',
        signInDifferent: 'Hyni si përdorues tjetër',
    },

    // Settings - Time ago strings
    timeAgo: {
        justNow: 'Sapo tani',
        minAgo: '{{count}} min më parë',
        hrAgo: '{{count}} orë më parë',
        daysAgo: '{{count}} ditë më parë',
    },

    // Settings - Security & Sessions
    security: {
        twoFactorTitle: 'Autentifikimi me dy faktorë',
        twoFactorDesc: 'Shto një shtresë shtesë sigurimi në llogarinë tënde.',
        enable2FA: 'Aktivizo 2FA',
    },
    sessions: {
        activeSessionsDesc: 'Këto janë të gjithë sesionet e tua të hapur në shfletues.',
        noActiveSessions: 'Nuk u gjetën sesione të aktive.',
        thisDevice: 'Ky pajisje',
    },
    danger: {
        deleteAccountDesc: 'Fshi përgjithmonë llogarinë tënde dhe të gjithë të dhënat e shoqëruara.',
    },
    deleteShop: {
        title: 'Fshi Dyqanin',
        desc: 'Fshirja e dyqanit tuaj do ta arkivojë atë dhe do të çaktivizojë të gjitha shërbimet. Të gjithë përdoruesit do të çkyçen.',
        dialogTitle: 'Fshi Dyqanin',
        dialogDesc: 'Fshirja e dyqanit tuaj do ta arkivojë atë dhe do të çaktivizojë të gjitha shërbimet.',
        confirmButton: 'Fshi Dyqanin',
    },

    // Update Password Form
    password: {
        updateTitle: 'Përditëso Fjalëkalimin',
        updateDesc: 'Përdor një fjalëkalim të gjatë, të rastësishëm për të mbajtur llogarinë tënde të sigurt.',
        currentPassword: 'Fjalëkalimi i tanishëm',
        newPassword: 'Fjalëkalim i ri',
        confirmNewPassword: 'Konfirmo fjalëkalimin e ri',
        updateButton: 'Përditëso fjalëkalimin',
        saved: 'U ruajt.',
        verifyTitle: 'Kontrollo email-in tënd',
        verifyDesc: 'Dërguam një kod 6-shifror në email-in tënd. Vendose më poshtë për të konfirmuar ndryshimin e fjalëkalimit.',
        verificationCode: 'Kodi i verifikimit',
        confirmChange: 'Konfirmo ndryshimin',
        didntReceive: 'Nuk e more kodin?',
        resend: 'Ridërgo',
        resendIn: 'Ridërgo kodin pas',
    },

    // Delete Account Form
    deleteAccount: {
        title: 'Fshi Llogarinë',
        desc: 'Sapo të fshihet llogarija jote, të gjithë të dhënat do të hiqen përgjithmonë. Ky veprim nuk mund të ndryshon.',
        dialogTitle: 'Fshi Llogarinë',
        dialogDesc: 'Kjo do të fshijë përgjithmonë llogarinë tënde dhe të gjithë të dhënat e shoqëruara. Fut fjalëkalimin dhe do të të dërgojmë një kod me email për ta konfirmuar.',
        shopWarning: 'Nëse je administratori i vetëm i sallonit, fshihet edhe salloni — me të gjitha rezervimet, klientët, shërbimet dhe llogaritë e stafit.',
        dialogDescEmail: 'Kjo do të fshijë përgjithmonë llogarinë tënde dhe të gjithë të dhënat e shoqëruara. Do të dërgojmë një kod në {{email}} për ta konfirmuar.',
        passwordPlaceholder: 'Fut fjalëkalimin tënd',
        cancelButton: 'Anulo',
        deleteButton: 'Fshi përgjithmonë',
        sendCodeButton: 'Më dërgo një kod',
        codeSent: 'Të dërguam një kod 6-shifror në {{email}}. Shkruaje për ta fshirë përgjithmonë llogarinë.',
        codeLabel: 'Kodi nga email-i',
        resendCode: 'Dërgo një kod të ri',
    },

    setup: {
        title: 'Fillo',
        done: 'të bëra',
        shopInfoLabel: 'Plotëso informacionin e dyqanit',
        shopInfoSub: 'Shto numrin e telefonit dhe adresën',
        shopInfoLink: 'Shko te Cilësimet',
        barbersLabel: 'Shto berberët tuaj',
        barbersSub: 'Konfiguro profilet dhe orët e punës',
        barbersLink: 'Shto Berberë',
        servicesLabel: 'Shto shërbimet tuaja',
        servicesSub: 'Përcakto ofertat me çmime dhe kohëzgjatje',
        servicesLink: 'Shto Shërbime',
        shareLink: 'Ndaj linkun e rezervimit',
        copy: 'Kopjo',
        copied: 'U kopjua!',
        ofComplete: '{{count}} nga {{total}} i plotësuar',
    },

    settingsPage: {
        bookingQrDesc: 'Vendose këtë kod QR në sallon. Klientët e skanojnë me aplikacionin GetFade ose me kamerë për të rezervuar.',
        bookingQrDownload: 'Shkarko kodin QR',
        legalPrivacy: 'Politika e privatësisë', legalTerms: 'Kushtet e shërbimit', legalCookies: 'Politika e cookies', legalSupport: 'Ndihmë & mbështetje',
        title: 'Cilësimet',
        bookingLink: 'Lidhja juaj e rezervimit',
        bookingLinkDesc: 'Ndani këtë lidhje që klientët të rezervojnë online',
        copyLink: 'Kopjo lidhjen',
        haircutPreview: 'Pamje paraprake e modeleve',
        haircutPreviewDesc: 'Klientët skanojnë këtë për të provuar modelet e flokëve me AI para rezervimit.',
        currencyUSD: 'USD — Dollar',
        currencyEUR: 'EUR — Euro',
        currencyALL: 'ALL — Lekë',
        shopInfo: 'Informacioni i Dyqanit',
        shopInfoDesc: 'Të dhënat bazë të dyqanit tuaj të dukshme për klientët.',
        shopName: 'Emri i Dyqanit',
        shopLogo: 'Logo i Dyqanit',
        shopLogoDesc: 'Shfaqet për klientët në faqen e rezervimit. JPG, PNG ose WebP, max 2MB.',
        languageDesc: 'Gjuha e përdorur në panelin për llogarinë tuaj.',
        uploadLogo: 'Ngarko Logo',
        changeLogo: 'Ndrysho Logo',
        fileTooLarge: 'Skedari është shumë i madh. Madhësia maksimale është {{max}}.',
        invalidFileType: 'Ju lutemi zgjidhni një skedar imazhi (JPG, PNG, WebP).',
        uploadFailed: 'Ngarkimi dështoi. Provoni një skedar më të vogël ose format tjetër.',
        timezone: 'Zona kohore',
        timezonePlaceholder: 'p.sh. Europe/Tirane',
        streetAddress: 'Adresa e rrugës',
        city: 'Qyteti',
        stateRegion: 'Shteti / Rajoni',
        zipPostal: 'Kodi postar',
        country: 'Vendi',
        googleMapsUrl: 'Linku i Google Maps',
        googleMapsUrlHint: 'Hap Google Maps, gjej dyqanin tënd, prek Share → Copy link, dhe ngjit linkun këtu.',
        currency: 'Valuta e paracaktuar',
        notifications: 'Njoftime',
        notificationsDesc: 'Kontrollo se si dëshiron të marrësh njoftimet për termina.',
        soundNotifications: 'Njoftime me zë',
        soundNotificationsDesc: 'Lëshon një zë kur marrësh njoftim.',
        emailNotifications: 'Njoftime me Email',
        emailNotificationsDesc: 'Merr njoftim përmes email kur termina futen ose përditësohen.',
        preferencesSaved: 'Preferencat e njoftimeve u ruajtën',
        settingsSaved: 'Cilësimet u ruajtën',
        virtualHaircut: 'Virtual Haircut Try-On',
        virtualHaircutDesc: 'Ndani këtë lidhje në mënyrë që klientët të mund të provojnë prerje floku me AI.',
        qrCode: 'QR Kodi',
        qrCodeDesc: 'Ndani këtë kod me klientët tuaj për qasje të lehtë të rezervimit.',
        qrCodeInfo: 'Drejtojeni kamerën e telefonit tuaj në këtë kod QR ose ndajeni në mediat sociale, faqen tuaj të internetit ose kudo që klientët tuaj mund ta gjejnë atë.',
        downloadQR: 'Shkarko QR Kodin',
        hairstylePreview: 'Parashikimi i Modelit të Flokëve',
        hairstylePreviewDesc: 'Ndani këtë lidhje që klientët të provojnë modele flokësh me AI.',
        bookingLanguage: 'Gjuha e faqes së rezervimit',
        bookingLanguageHint: 'Gjuha në të cilën shfaqet linku juaj publik i rezervimit (faqja që përdorin klientët). Kjo është e ndryshme nga gjuha e panelit tuaj.',
        autoConfirmTitle: 'Konfirmo automatikisht rezervimet',
        autoConfirmDesc: 'Kur është aktiv, rezervimet në vendet e lira konfirmohen automatikisht — nuk nevojitet miratim manual. Kur është joaktiv, çdo rezervim vjen si pezull dhe ju vendosni ta konfirmoni ose ta refuzoni.',
        requireAccountsTitle: 'Kërko llogari për klientët',
        requireAccountsDesc: 'Kur është aktiv, klientët duhet të regjistrohen ose të kyçen para se të rezervojnë. Kur është joaktiv, linku i rezervimit shkon direkt te forma dhe klientët vetëm shkruajnë emrin dhe numrin e telefonit.',
        slotIntervalTitle: 'Orari i rezervimit',
        slotIntervalDesc: 'Sa shpesh mund të fillojnë rezervimet. 15 min = 9:00, 9:15, 9:30… 30 min = 9:00, 9:30, 10:00…',
        defaultLanguage: 'Gjuha parazgjedhje e rezervimit',
        defaultLanguageHint: 'Klientët do të shohin këtë gjuhë si parazgjedhje. Ata mund ta ndryshojnë atë në profilin e tyre.',
    },

    notif: {
        title: 'Njoftimet',
        markAllRead: 'Shëno të gjitha si të lexuara',
        noNotifications: 'Nuk ka njoftime ende',
        view: 'Shiko',
        markAsRead: 'Shëno si të lexuar',
        showMore: 'Shfaq më shumë',
    },

    reports: {
        title: 'Raportet',
        revenue: 'Të ardhura',
        appointments: 'Terminet',
        completed: 'Të përfunduara',
        cancelled: 'Të anuluara',
        noShows: 'Mungesa',
        tipsCollected: 'Bakshishe të mbledhura',
        byBarber: 'Sipas Berberit',
        byService: 'Sipas Shërbimit',
        completionRate: 'Shkalla e përfundimit',
        avgTicket: 'Mesatare për termin',
        topPerformer: 'Më i miri',
        tipsLabel: 'bakshishe',
        apptsLabel: 'termina',
        noData: 'Nuk ka të dhëna për këtë periudhë.',
        export: 'Eksporto',
        exportPdf: 'PDF',
        exportXlsx: 'Excel',
        exportCsv: 'CSV',
        dateRange: 'Periudha',
        from: 'Nga',
        to: 'Deri',
        apply: 'Filtro',
        reset: 'Fshij',
    },

    admin: {
        title: 'Admin i Platformës',
        superAdmin: 'Super Admin',
        overview: 'Pasqyra',
        shops: 'Dyqanet',
        activity: 'Aktiviteti',
        platformOverview: 'Pasqyra e Platformës',
        allShops: 'Të Gjitha Dyqanet',
        recentActivity: 'Aktiviteti i Fundit',
        totalRevenue: 'Të Ardhura Totale',
        totalBookings: 'Rezervime Totale',
        activeShops: 'Dyqane Aktive',
        customers: 'Klientë',
        bookings30d: 'Rezervime · 30 ditët e fundit',
        revenue6m: 'Të ardhura · 6 muajt e fundit',
        topShops: 'Dyqanet Kryesore · këtë muaj',
        statusBreakdown: 'Analiza e Statusit',
        newShops: 'Dyqane të Reja · 7 ditët e fundit',
        recentBookings: 'Rezervimet e Fundit',
        viewAll: 'Shiko të gjitha →',
        activeShopsLabel: 'Dyqane aktive',
        todayBookings: 'Rezervimet e sotme',
        cancelRate: 'Shkalla e anulimit',
        live: 'Live',
        noData: 'Nuk ka të dhëna ende.',
        noActivity: 'Nuk ka aktivitet ende.',
        noNewShops: 'Nuk ka dyqane të reja këtë javë.',
        last30: 'Të fundit 30',
        vsLastMonth: '% krahasuar me muajin e kaluar',
        signOut: 'Dil',
        joined: 'U bashkua',
        booked: 'rezervuar',
        totalLabel: 'total',
        inactiveLabel: 'joaktiv',
        total: 'total',
        today: 'sot',
        archived: 'Arkivuara',
        archivedShops: 'Dyqane te Arkivuara',
        archivedShopsCount: 'dyqane te arkivuara',
        noArchivedShops: 'Nuk ka dyqane te arkivuara.',
        restore: 'Rikthe',
        companies: 'Kompanite',
        users: 'Përdoruesit',
        plans: 'Planet',
        subscriptions: 'Abonimet',
        auditLogs: 'Regjistri i Auditimit',
        roles: 'Rolet & Lejet',
        settings: 'Cilësimet',
        createCompany: 'Krijo Kompani',
        editCompany: 'Ndrysho Kompaninë',
        companyDetails: 'Detajet e Kompanisë',
        deleteCompany: 'Fshi Kompaninë',
        deleteCompanyConfirm: 'A jeni i sigurt që dëshironi ta fshini këtë kompani? Kompania dhe të gjitha të dhënat do të fshihen përkohësisht.',
        forceDeleteConfirm: 'Ky veprim është i përhershëm dhe nuk mund të zhbëhet. Të gjitha të dhënat e kompanisë do të humben.',
        suspendCompany: 'Pezullo Kompaninë',
        activateCompany: 'Aktivizo Kompaninë',
        impersonate: 'Hyr si Admin',
        stopImpersonation: 'Kthehu te Admin',
        impersonating: 'Hyrë si',
        createUser: 'Krijo Përdorues',
        editUser: 'Ndrysho Përdoruesin',
        userDetails: 'Detajet e Përdoruesit',
        deleteUser: 'Fshi Përdoruesin',
        deleteUserConfirm: 'A jeni i sigurt që dëshironi ta fshini këtë përdorues?',
        resetPassword: 'Rivendos Fjalëkalimin',
        resetPasswordConfirm: 'Gjenero një fjalëkalim të ri të përkohshëm për këtë përdorues?',
        assignRole: 'Cakto Rolin',
        createPlan: 'Krijo Plan',
        editPlan: 'Ndrysho Planin',
        deletePlan: 'Fshi Planin',
        deletePlanConfirm: 'A jeni i sigurt që dëshironi ta fshini këtë plan?',
        assignPlan: 'Cakto Planin',
        changePlan: 'Ndrysho Planin',
        cancelSubscription: 'Anulo Abonimin',
        allCompanies: 'Të gjitha Kompanite',
        activeOnly: 'Vetëm Aktive',
        inactiveOnly: 'Vetëm Joaktive',
        allUsers: 'Të gjithë Përdoruesit',
        allRoles: 'Të gjitha Rolet',
        allStatuses: 'Të gjitha Statuset',
        search: 'Kërko...',
        noResults: 'Nuk u gjet asnjë rezultat.',
        actions: 'Veprimet',
        status: 'Statusi',
        role: 'Roli',
        company: 'Kompania',
        email: 'Email',
        phone: 'Telefoni',
        name: 'Emri',
        createdAt: 'Krijuar',
        barbers: 'Berberat',
        services: 'Shërbimet',
        appointments: 'Terminet',
        revenue: 'Të ardhurat',
        lastBooking: 'Rezervimi i fundit',
        unlimited: 'Pa limit',
        perMonth: '/muaj',
        perYear: '/vit',
        free: 'Falas',
        trial: 'Provë',
        active: 'Aktiv',
        inactive: 'Joaktiv',
        pastDue: 'I vonuar',
        cancelled: 'Anuluar',
        expired: 'Skaduar',
        save: 'Ruaj',
        saving: 'Duke ruajtur...',
        confirm: 'Konfirmo',
        permanentDelete: 'Fshi Përgjithmonë',
        editPermissions: 'Ndrysho Lejet',
        permissionsCount: 'Lejet',
        rolesCount: 'role',
        all: 'Të gjitha',
        allPermissionsLocked: 'Të gjitha lejet (të kyçura)',
        permissionMatrix: 'Matrica e Lejeve',
        permission: 'Leja',
        cancel: 'Anulo',
        more: 'më shumë',
        viewUsers: 'Shiko Përdoruesit',
        general: 'Të përgjithshme',
        security: 'Siguria',
        features: 'Veçoritë',
        maintenance: 'Mirëmbajtja',
        maintenanceMode: 'Modaliteti i Mirëmbajtjes',
        maintenanceModeDesc: 'Aktivizo modalitetin e mirëmbajtjes për të çaktivizuar platformën përkohësisht.',
        appName: 'Emri i Aplikacionit',
        defaultTimezone: 'Zona Kohore e Paracaktuar',
        supportEmail: 'Email Mbështetjes',
        registrationEnabled: 'Regjistrimi i Aktivizuar',
        requireEmailVerification: 'Kërko Verifikimin e Email-it',
    },

    apptIndex: {
        appointments: 'Terminet',
        fullyBooked: 'I plotë',
        selected: '{{count}} të zgjedhura',
        confirmAll: 'Konfirmo të gjitha',
        cancelAll: 'Anulo të gjitha',
        clear: 'Pastro',
        confirmApptTooltip: 'Konfirmo terminin',
        namePlaceholder: 'Arben Gashi',
        phonePlaceholder: '+355 6X XXX XXXX',
        minLabel: 'min',
        nowLabel: 'Tani',
        searchPlaceholder: 'Kërko sipas emrit, berberi ose shërbimi…',
        filterStatusAll: 'Të gjitha statuset',
        filterDateAll: 'Të gjitha datat',
        filterDateLast7d: '7 ditët e fundit',
        filterDateLast30d: '30 ditët e fundit',
        filterDateLast90d: '90 ditët e fundit',
        calendar: 'Kalendar',
        list: 'Listë',
        kanban: 'Kanban',
    },

    // Landing page
    land: {
        // Navbar
        navHowItWorks: 'Si funksionon',
        navFeatures: 'Çfarë përfiton',
        navPricing: 'Çmimet',
        navSupport: 'Pyetje?',
        navLogin: 'Hyr',
        navBook: 'Rezervo tani',
        // Hero
        heroHeading: 'Mjaft me rezervimet me letër',
        heroLabel: '✨ Menaxhimi i berberit, i thjeshtuar',
        heroTitle: 'Gjithçka që të duhet për të menaxhuar berberin — në një sistem të vetëm',
        heroSub: 'GetFade zëvendëson rezervimet manuale, telefonatat dhe tabelat me një sistem të plotë digjital.',
        heroBtn: 'Fillo falas',
        heroBtn2: 'Si funksionon',
        heroBenefits: '✓ Gati për pak minuta • Nuk kërkohen njohuri teknike • I ndërtuar për berbera realë',
        heroTrust: 'berberi që përdorin GetFade',
        heroRating: 'nga 2,000+ vlerësime',
        // Problem & Solution
        problemLabel: 'Problemet e tu',
        problemHeading: 'Menaxhimi i berberisë është i rraskapitur',
        problemSub: 'Termeet i marrin dy herë, klientët nuk vijnë, nuk di sa fitoj. Ta njeh?',
        problem1: 'Termeet i marrin dy herë dhe kaos',
        problem2: 'Stoqet janë një kaos',
        problem3: 'Klientët zhduken',
        problem4: 'Ekipi nuk e di çfarë ndodh',
        solutionLabel: 'Zgjidhja jonë',
        solutionHeading: 'GetFade e bën të lehtë',
        solutionSub: 'Një sistem për gjithçka. Rezervim smart, kujtesa automatike, numra të vërteta.',
        solution1: 'Rezervim smart',
        solution2: 'Pa termete të dyfishta',
        solution3: 'Klientët të lumtur',
        solution4: 'Ekipi bashkëpunon më mirë',
        // Features
        featuresLabel: 'Çfarë do të marrësh',
        featuresHeading: 'Mjete për berbera të vërteta',
        featuresSub: 'E thjeshtë. Praktike.',
        feature1Title: 'Rezervim online që funksionon',
        feature1Desc: 'Klientët rezervojnë online, kalendari yt përditësohet automatikisht. Asnjë term i dyfishtë më.',
        feature2Title: 'Menaxho barberat e tu',
        feature2Desc: 'Kush punon kur, kush ka ditë pushimi, kush është më i mirë në çfarë.',
        feature3Title: 'Shiko numrat e tu',
        feature3Desc: 'Sa fitoj, cilat shërbime janë të njohura, ku vjen paraja.',
        feature4Title: 'Shërbimet e tu, çmimet e tu',
        feature4Desc: 'Prerjet e tua, ngjyrosja dhe gjithçka tjetër që ofron — me çmimet e tua.',
        feature5Title: 'Klientët rezervojnë 24/7',
        feature5Desc: 'Ndaji një lidhje. Ata rezervojnë kur duan, madje edhe në natë.',
        feature6Title: 'Në Anglisht, Gjermanisht, Shqip',
        feature6Desc: 'Klientët e tu rezervojnë në gjuhën e tyre.',
        // Feature cards (grid section)
        featureCardMobileTitle: 'Rezervim nga telefoni',
        featureCardMobileDesc: 'Përvojë e shpejtë dhe e bukur në çdo pajisje. Klientët rezervojnë në sekonda.',
        featureCardRemindersTitle: 'Kujtesa automatike',
        featureCardRemindersDesc: 'Kujtesa me email reduktojnë mungesat dhe mbajnë klientët të informuar.',
        featureCardAnalyticsTitle: 'Analitikë biznesi',
        featureCardAnalyticsDesc: 'Shiko të ardhurat, shërbimet më të kërkuara, tendencat e klientëve dhe rritjen e biznesit lehtësisht.',
        featureCardCollabTitle: 'Bashkëpunim në ekip',
        featureCardCollabDesc: 'Ndaj oraret, shënimet dhe informacionet e klientëve me ekipin në kohë reale.',
        featureCardSecureTitle: 'I sigurt dhe i besueshëm',
        featureCardSecureDesc: 'Siguri në nivel banke me të dhëna të enkriptuara. 99.9% kohë funksionimi.',
        featureCardFastTitle: 'Shpejtësi maksimale',
        featureCardFastDesc: 'Faqet hapen menjëherë, edhe në internet të ngadaltë.',
        // Stats
        statsLabel: 'Rezultate të vërteta nga berbera të vërtetë',
        stat1Value: '+45%',
        stat1Label: 'Më shumë rezervime',
        stat2Value: '-70%',
        stat2Label: 'Më pak mungesa',
        stat3Value: '3+ orë',
        stat3Label: 'Të kursyera çdo ditë',
        stat4Value: '+€5K',
        stat4Label: 'Të ardhura mujore',
        // Comparison
        comparisonHeading: 'Pse GetFade e mund metodën e letrës dhe kaosit',
        comparisonSub: 'Krahaso mënyrën e vjetër me mënyrën e GetFade',
        comparisonLabel: 'Veçoria',
        comparisonTraditional: 'Tradicionalja (letra, telefoni, etj.)',
        comparisonFade: 'GetFade',
        comparisonFeature1: 'Menaxhimi i termineve',
        comparisonFeature1Traditional: 'Letër, telefon, shënime kudo — kaos i plotë',
        comparisonFeature1Fade: 'Një sistem qendror, të gjitha terminet të dukshme',
        comparisonFeature2: 'Ndjekja e të ardhurave',
        comparisonFeature2Traditional: 'Numëro paratë në fund të ditës — pa asnjë pasqyrë',
        comparisonFeature2Fade: 'Të ardhurat sipas ditës, berberit dhe shërbimit, me tendencat',
        comparisonFeature3: 'Koordinim i ekipit',
        comparisonFeature3Traditional: 'Kaos — askush nuk e di kush punon e kush ka pushim',
        comparisonFeature3Fade: 'Oraret e punës, pushimet dhe terminet e çdo berberi në një vend',
        comparisonFeature4: 'Historiku i klientit',
        comparisonFeature4Traditional: 'Shënime të shpërndara — asnjë pasqyrë e vërtetë',
        comparisonFeature4Fade: 'Vizitat, mungesat dhe berberi i preferuar për çdo klient',
        comparisonFeature5: 'Rritja e biznesit',
        comparisonFeature5Traditional: 'Rritet me ty deri diku — pastaj shembet',
        comparisonFeature5Fade: 'Rritet me ty, nga 1 deri në 50+ berberë, pa probleme',
        // Testimonials
        testimonialsTitle: 'Pëlqyer nga berberë',
        testimonialsSub: 'Shih se çfarë thonë berberët e vërtetë për GetFade',
        // Pricing
        pricingLabel: 'Çmimet',
        pricingHeading: 'E thjeshtë dhe transparente',
        pricingSub: '',
        pricingDesc: 'Një plan i thjeshtë për çdo sallon: falas për 3 muaj, pastaj €10 në muaj. Pa kartë krediti për të filluar, anulo kur të duash.',
        pricingTrialDesc: 'Fillo provën 3-mujore pa kartë krediti.',
        planStarterName: 'Solo',
        planStarterPrice: 'Falas',
        planStarterPer: 'përgjithmonë',
        planStarterDesc: 'Nëse po fillon.',
        planStarterFeature1: '1 dyqan',
        planStarterFeature2: 'Deri në 3 barbera',
        planStarterFeature3: 'Rezervim online',
        planStarterFeature4: 'Dashbord bazik',
        planProName: 'Dyqan',
        planProPrice: '€29',
        planProPer: '/muaj',
        planProDesc: 'Për dyqanet në rritje.',
        planProBadge: 'Shumica zgjedhin këtë',
        planProFeature1: 'Barbera të pakufizuar',
        planProFeature2: 'Shiko numrat e tu',
        planProFeature3: 'Klientë të lumtur',
        planProFeature4: 'Ndihmë e shpejtë',
        planEnterpriseName: 'Zinxhir',
        planEnterprisePrice: 'Le të flasim',
        planEnterpriseDesc: 'Për biznese më të mëdha.',
        planEnterpriseFeature1: 'Shumë dyqane',
        planEnterpriseFeature2: 'Gjithçka e përshtatur',
        planEnterpriseFeature3: 'Ekipi yt',
        planCTA: 'Provo tani',
        planContactUs: 'Më thuaj',
        // Pricing Plans (new names)
        planName1: 'Fillestar',
        planPrice1: 'Falas',
        planDesc1: 'Perfekt për berbera që sapo po fillojnë',
        planFeature1_1: 'Faqe për rezervime online',
        planFeature1_2: '1 lokacion',
        planFeature1_3: 'Deri në 3 berbera',
        planFeature1_4: 'Dashboard i thjeshtë për menaxhim',
        planName2: 'Pro',
        planPrice2: '€10/muaj',
        planDesc2: 'Për berbera që duan të rriten më shpejt dhe të qëndrojnë gjithmonë të zënë',
        planBadge2: '3 muaj falas',
        planSubtext2: 'Kthe mbrapsht abonimin tënd me vetëm 1 klient shtesë',
        pricingFact1: "për 3 muajt e parë",
        pricingFact2: "në muaj pas kësaj",
        pricingFact3: "komision nga rezervimet",
        planFeature2_1: 'Gjithçka në Fillestar',
        planFeature2_2: 'Berbera të pakufizuar dhe qasje ekipi',
        planFeature2_3: 'Kujtesa automatike me email (ul mungesat)',
        planFeature2_4: 'Shiko të ardhurat dhe performancën në kohë reale',
        planFeature2_5: 'Menaxho të gjithë ekipin tënd nga një dashboard',
        planName3: 'Enterprise',
        planPrice3: 'Çmim i personalizuar',
        planDesc3: 'Për biznese me shumë lokacione',
        planFeature3_1: 'Menaxhim i shumë lokacioneve',
        planFeature3_2: 'Dashboard i centralizuar për të gjitha dyqanet',
        planFeature3_3: 'Integrime të personalizuara',
        planFeature3_4: 'Suport i dedikuar',
        planFeature3_5: 'Qasje API',
        // How It Works Steps
        step1Title: 'Konfiguro berberin tënd',
        step1Desc: 'Shto shërbimet, stafin dhe oraret për disa minuta.',
        step2Title: 'Ndaj linkun e rezervimit',
        step2Desc: 'Klientët rezervojnë direkt përmes një linku në Instagram, WhatsApp ose në faqen tënde.',
        step3Title: 'Menaxho gjithçka automatikisht',
        step3Desc: 'Rezervimet, kujtesat dhe oraret menaxhohen për ty — pa telefonata, pa stres.',
        // Smart Scheduling Section
        smartSchedulingTitle: 'Qëndro gjithmonë i rezervuar — pa mbingarkesë',
        smartSchedulingDesc: 'Planifikimi inteligjent mbush ditën tënde në mënyrë efikase duke shmangur boshllëqet dhe konfliktet.',
        smartSchedulingFeature1: 'Kalendar i zgjuar',
        smartSchedulingFeature1Desc: 'Shiko të gjithë orarin në një vend dhe menaxho rezervimet menjëherë.',
        smartSchedulingFeature2: 'Optimizim i kohës',
        smartSchedulingFeature2Desc: 'Zvogëlo boshllëqet midis takimeve dhe shfrytëzo sa më shumë të mundesh çdo ditë.',
        smartSchedulingFeature3: 'Koordinim i ekipit',
        smartSchedulingFeature3Desc: 'Menaxho disa berbera dhe mbaji të gjithë të organizuar pa vështirësi.',
        // Footer additions
        colSupport: 'Suport',
        linkPricing: 'Çmimi',
        linkDemo: 'Demo',
        linkHelp: 'Qendra e Ndihmës',
        linkContact: 'Kontakt',
        // Features Section (new for redesign)
        featuresFeature1: 'Planifikimi i zgjuar',
        featuresDesc1: 'Rezervim automatik i takimeve me disponibilitet në kohë reale dhe konfirmimet e menjëhershme të klientëve.',
        featuresFeature2: 'Menaxhimi i ekipit',
        featuresDesc2: 'Menaxhoni berberat, caktoni shërbime, vendosni oralet dhe ndiqni performancën në një vend.',
        featuresFeature3: 'Ndjekja e Ardhurave',
        featuresDesc3: 'Pasqyra në kohë reale mbi fitimin, shërbimet popullore dhe metrikat e rritjes së biznesit.',
        featuresFeature4: 'Profili i Klientit',
        featuresDesc4: 'Ruani preferencat, historikun e shërbimit dhe shënimet për secilin klient.',
        // Stats Section (new for redesign)
        statsBarbershops: 'berberat po rriten me GetFade',
        statsAppointments: 'takimet e rezervuara çdo muaj',
        statsRevenue: 'të ardhura të përpunuara',
        statsSupport: 'mbështetje kur ju duhet',
        // CTA Section (new for redesign)
        ctaTitle: 'Gati të transformoni berberin tuaj?',
        ctaSub: 'Bashkohuni me mijëra berberë që tashmë përdorin GetFade për të rezervuar më shumë takime dhe për të fituar më shumë të ardhura.',
        // Lock in Loyalty
        retentionLabel: 'Rritja',
        loyaltyHeading: 'Zgjero Bazën\ne Klientit',
        loyaltySub: 'Jepuni klientëve një përvojë të lehtë rezervimi. Zvogëloni mungesat dhe ndërtoni një bazë të fortë klientësh.',
        loyaltyBtn: 'Aktivizo Rezervimin',
        // Features Showcase (section 2)
        showcaseLabel: 'Veçori të Fuqishme',
        showcaseTitle: 'Gjithçka që keni nevojë për të drejtuar dyqanin tuaj',
        showcaseSub: 'Menaxhoni operacionet e dyqanit tuaj në mënyrë efikase në mënyrë që ju mund të përqendroheni në prerje të shkëlqyese.',
        showcaseFeature1Title: 'Rezervim i Zgjuar',
        showcaseFeature1Desc: 'Planifikimi automatik me konfirmime të menjëhershme, kujtesore dhe reduktim të mungesave',
        showcaseFeature2Title: 'Profile Klientësh',
        showcaseFeature2Desc: 'Ruani preferencat, shënimet dhe historikun e shërbimit për secilin klient të rregullt',
        showcaseFeature3Title: 'Menaxhimi i Ekipit',
        showcaseFeature3Desc: 'Caktoni berberat, ndjekni orarele individuale dhe menaxhoni shpërndarjen e punës',
        showcaseFeature4Title: 'Analitika & Raportet',
        showcaseFeature4Desc: 'Njohuri në kohë reale mbi të ardhurat, takimet, tendencat e klientit dhe më shumë',
        showcaseFeature5Title: 'Portali i Klientit',
        showcaseFeature5Desc: 'Lidhja e ndarë e rezervimit për rezervime të lehta të klientit, kudo, në çdo kohë',
        showcaseFeature6Title: 'Ndjekja e Performancës',
        showcaseFeature6Desc: 'Monitoroni performancën e berberjve, vlerësimet dhe metrikat e përfundimit të shërbimit',
        // FAQ
        faqLabel: 'Pyetje?',
        faqTitle: 'Pyetje të shpeshta',
        faqSub: 'Gjithçka që duhet të dini rreth GetFade.',
        faqQ1: 'Si filloj me GetFade?',
        faqA1: 'Regjistrohuni për një llogari falas, shtoni shërbimet dhe çmimet tuaja, shtoni berberat tuaj dhe filloni të pranoni rezervime. Shumica e berberave janë gati në më pak se 10 minuta.',
        faqQ2: 'A ka tarifa fillimi ose kërkohet kartë krediti?',
        faqA2: "Jo. Nuk ka tarifë fillimi dhe nuk kërkohet kartë krediti. Merrni gjithë produktin falas për 3 muaj, pastaj kushton €10 në muaj.",
        faqQ3: 'A mund të menaxhoj disa vendndodhje?',
        faqA3: "Aktualisht, çdo llogari GetFade menaxhon një rruajtore. Nëse keni disa vendndodhje, mund të krijoni një llogari të veçantë për secilën.",
        faqQ4: 'Si rezervojnë klientët e mi takimet?',
        faqA4: 'Klientët tuaj rezervojnë përmes lidhjes tuaj të personalizuar. Ata zgjedhin shërbimin, berberin dhe kohën — dhe konfirmojnë menjëherë.',
        faqQ5: 'A mund të anulohen ose riplanifikohen takimet?',
        faqA5: 'Po, klientët mund të menaxhojnë rezervimet e tyre në varësi të cilësimeve tuaja.',
        faqQ6: "Çfarë ndodh kur mbarojnë 3 muajt falas?",
        faqA6: "Asgjë nuk paguhet automatikisht, sepse nuk ju kërkuam kartë. Për të vazhduar me GetFade, kaloni në planin €10 në muaj. Nëse jo, paneli, aplikacioni dhe faqja e rezervimeve fiken derisa të vazhdoni, dhe të dhënat tuaja mbeten të ruajtura.",
        faqQ7: "A merrni përqindje nga rezervimet e mia?",
        faqA7: "Jo. Paguani një shumë fikse prej €10 në muaj, qoftë për 20 apo 2.000 rezervime. Atë që u faturoni klientëve e mbani ju, pa komision dhe pa tarifa për rezervim.",
        // Barbers & Clients
        forLabel: 'Për',
        barbersTitle: 'Berberat',
        businessTitle: 'Berberat',
        barbersSub: 'Merr kontrollin e orarit, klientëve, të ardhurave dhe markës tënde.',
        findOutHow: 'Mëso më shumë',
        // Shop Stories
        testimonialsLabel: 'Historitë e suksesit',
        shopStoriesTitle: 'Historitë e Suksesit të Berberave',
        shopStoriesSub: 'Berberi të vërtetë, rritja e vërtetë.',
        // Get Free
        startTodayLabel: 'Fillo Tani',
        getFreeTitle: 'Menaxho Berberin\nTuaj',
        getFreeSub: 'Konfiguro në minuta. Nuk kërkohet kartë krediti. Fillo të pranosh rezervime online sot.',
        getFreeBtn: 'Fillo Falas',
        // Footer
        footerTagline: 'Sistemi i kompletë i menaxhimit për berberat. I thjeshtë, i fuqishëm dhe i besueshëm.',
        colProduct: 'Produkti',
        colCompany: 'Kompania',
        colResources: 'Burimet',
        colLegal: 'Juridike',
        linkHowItWorks: 'Si funksionon',
        linkStories: 'Histori',
        linkGetStarted: 'Fillo tani',
        linkAbout: 'Rreth nesh',
        linkBlog: 'Blog',
        linkCareers: 'Punësim',
        linkPrivacy: 'Privatësia',
        linkTerms: 'Kushtet e Përdorimit',
        linkSecurity: 'Siguria',
        linkCookies: 'Cookies',
        supportLabel: 'Na kontaktoni',
        supportTitle: 'Keni ndonjë pyetje?',
        supportSub: 'Lëreni emailin tuaj dhe do t\'ju përgjigjemi sa më shpejt të jetë e mundur.',
        supportPlaceholder: 'emaili@juaj.com',
        supportBtn: 'Dërgo',
        supportSent: 'E morëm mesazhin tuaj — do t\'ju shkruajmë së shpejti.',
        copyright: '© 2026 GetFade. Të gjitha të drejtat e rezervuara.',
        builtBy: 'Ndërtuar për berberë, nga berberë.',
        madeBy: 'Krijuar nga',
        // an2tech section
        an2techLabel: 'Ekipi pas kësaj',
        an2techHeading: 'Dëshiron një produkt si ky\npër biznesin tënd?',
        an2techSub: 'an2tech ndërton aplikacione moderne, platforma SaaS dhe mjete dixhitale — shpejt, pastër dhe gati për prodhim.',
        an2techBtn: 'Punojmë bashkë',
        an2techTagline: 'Dizajn · Zhvillim · Lansim',
        // Cookie banner
        cookieText: 'Përdorim vetëm cookies thelbësore për t’ju mbajtur të kyçur. Cookies opsionale do të përdoreshin vetëm nëse i pranoni.',
        cookieAccept: 'Prano',
        cookieDecline: 'Refuzo',
        cookieLearnMore: 'Mëso më shumë',
    },

    // Toast notifications
    toast: {
        notificationsMarkedAsRead: 'Të gjitha notifimet u shënuan si të lexuar',
        walkinBooked: 'Walk-in i rezervuar për {{name}}.',
        goalsUpdated: 'Objektivat u përditësuan.',
        sponsorAdded: 'Sponsori u shtua.',
        sponsorUpdated: 'Sponsori u përditësua.',
        sponsorRemoved: 'Sponsori u hoq.',
        serviceCreated: 'Shërbimi u krijua.',
        serviceUpdated: 'Shërbimi u përditësua.',
        serviceDeleted: 'Shërbimi u fshi.',
        newBooking: 'Rezervim i ri!',
        newBookingFrom: 'Rezervim i ri nga {{name}}',
        aCustomer: 'Një klient',
        autoConfirmedFrom: 'Rezervim i ri i konfirmuar: {{name}}',
        autoConfirmedEyebrow: 'Termini i ri · Konfirmuar',
        bookingConfirmed: 'Rezervimi u konfirmua',
        bookingDeclined: 'Rezervimi u refuzua',
        customerCreated: 'Klienti u shtua me sukses.',
        customerDeleted: 'Klienti u fshi.',
        appointmentCreated: 'Termini u krijua.',
        appointmentUpdated: 'Termini u përditësua.',
        appointmentConfirmed: 'Termini u konfirmua.',
        appointmentDeclined: 'Termini u refuzua.',
        appointmentCancelledByStaff: 'Termini u anulua.',
        appointmentStatusUpdated: 'Statusi i terminit u përditësua.',
        appointmentDeleted: 'Termini u fshi.',
        barberCreated: 'Berberi u krijua.',
        barberUpdated: 'Berberi u përditësua.',
        barberDeleted: 'Berberi u fshi.',
        barberAvailable: 'Berberi është tani i disponueshëm.',
        barberUnavailable: 'Berberi shënuar i padisponueshëm për sot.',
        scheduleUpdated: 'Orari u përditësua.',
        timeOffAdded: 'Pushimi u shtua.',
        timeOffRemoved: 'Pushimi u hoq.',
        shopActivated: 'Dyqani u aktivizua.',
        shopDeactivated: 'Dyqani u çaktivizua.',
        shopRestored: 'Dyqani u rikthye me sukses.',
        shopPermanentlyDeleted: 'Dyqani u fshi përgjithmonë.',
        productCreated: 'Produkti u krijua.',
        productUpdated: 'Produkti u përditësua.',
        productDeleted: 'Produkti u fshi.',
        haircutCreated: 'Prerja e flokut u krijua.',
        haircutUpdated: 'Prerja e flokut u përditësua.',
        haircutDeleted: 'Prerja e flokut u fshi.',
        passwordReset: 'Fjalëkalimi u rivendos me sukses.',
    },
    dialogs: {
        confirmDeleteTimeOff: 'A jeni i sigurt që dëshironi të hiqni këtë pushim?',
        confirmDeleteAd: 'Fshij këtë reklamë?',
        confirmCancelAppointment: 'Anulo këtë takim?',
    },

    // Virtual Haircut
    virtualHaircut: {
        pageTitle: 'Provo stilin e flokëve',
        pageDescription: 'Zgjidhni një stil në të majtë, shikoni pamjen paraparje në të djathtë',
        chooseYourStyle: 'Zgjidhni Stilin Tuaj',
        chooseYourStyleDesc: 'Zgjidhni një stil flokësh për të parë se si duket me foton tuaj',
        chooseStyleFirst: 'Zgjidhni fillimisht një stil',
        chooseStyleFirstDesc: 'Zgjidhni një stil flokësh nga e majta, pastaj hapni kamerën tuaj për ta provuar.',
        yourPhoto: 'Fotoja Juaj',
        yourPhotoDesc: 'Bëni një selfie për të filluar',
        readyToTryOn: 'Gati të provoni?',
        readyToTryOnDesc: 'Bëni një selfie për të parë se si duken stilet e ndryshme të flokëve në ju',
        openCamera: 'Hap Kamerën',
        cameraPermissionRequired: 'Kërkohet Lejidhjet e Kamerës',
        allowCameraAccess: 'Lejojeni qasjen në kamerë në cilësimet e shfletuesit tuaj',
        aiPreview: 'Pamja me AI',
        generatingPreview: 'Pamja paraparje po gjenerohet...',
        upTo30Seconds: 'Deri në 30 sekonda',
        retakePhoto: 'Bëj Sërish Foton',
        bookThisHaircut: 'Krijo një termin me këtë stil',
        proTips: 'Këshilla pro',
        goodLighting: 'Ndriçimi i mirë ndihmon me saktësinë',
        faceCameraDirectly: 'Përballojini drejtpërdrejt kamerën',
        tryAllStyles: 'Provoni të gjithë stilet para se të përshkruani',
        howItWorks: 'Si funksionon',
        helpStep1Title: 'Zgjidhni një stil flokësh',
        helpStep1Desc: 'Shfletoni stilet në të djathtë dhe klikoni atë që dëshironi të provoni.',
        helpStep2Title: 'Bëni një selfie',
        helpStep2Desc: 'Përdorni kamerën ose ngarkoni një foto. Shikoni drejt me ndriçim të mirë.',
        helpStep3Title: 'Shikoni pamjen paraprake',
        helpStep3Desc: 'AI gjeneron një pamje paraprake me stilin e zgjedhur. Provoni sa më shumë stile të dëshironi!',
        gotIt: 'E kuptova',
        uploadPhoto: 'Ngarko foto',
        generatePreview: 'Gjenero pamjen',
        serviceUnavailable: 'Kjo veçori nuk është e disponueshme për momentin. Ju lutem provoni më vonë.',
        updatingTitle: 'Po përmirësojmë këtë veçori',
        updatingDesc: 'Ju lutem provoni përsëri pas pak — po bëjmë gjërat më të mira për ju.',
        openingCamera: 'Po hapet kamera...',
        before: 'Para',
        after: 'Pas',
        tryAnotherStyle: 'Provo stil tjetër',
        hairColor: 'Ngjyra e flokëve',
        colors: {
            natural: 'Natyrale',
            black: 'E zezë',
            darkBrown: 'Kafe',
            blonde: 'Bionde',
        },
    },

    notifications: {
        title: 'Njoftime',
        newBookings: 'Rezervime të reja',
        today: 'Terminet e sotme',
        empty: 'Nuk ka termine sot',
        upcoming: 'Ke {{count}} termine të ardhshme',
        upcomingWithTime: 'Ke {{count}} termine të ardhshme — i pari në {{time}}',
        tomorrow: 'Ke {{count}} termine për nesër',
        tomorrowWithTime: 'Ke {{count}} termine për nesër — i pari në {{time}}',
        allClearTitle: 'Asgjë e re',
        allClearBody: 'Nuk ka termine sot apo nesër.',
        seeAll: 'Shiko të gjitha',
        unread: 'palexuara',
        summary: {
            total: 'Gjithsej sot',
            inProgress: 'Në proces',
            completed: 'Të përfunduara',
            next: 'Tjetri',
            now: 'Tani',
            inMinutes: 'pas {{m}} min',
            inHours: 'pas {{h}}h {{m}}m',
        },
    },

    bookingAuth: {
        keepSignedIn: "Më mbaj të kyçur",
        verifyTitle: "Konfirmo email-in tënd",
        verifySub: "Dërguam një kod me 6 shifra te {{email}}. Shkruaje më poshtë për ta përfunduar llogarinë.",
        verifyCodeLabel: "Kodi i verifikimit",
        verifyBtn: "Konfirmo email-in",
        verifying: "Duke konfirmuar…",
        verifyResend: "Nuk e more? Dërgo një kod të ri",
        verifyResent: "Një kod i ri është nisur.",
        verifySending: "Duke dërguar…",
        forgotTitle: "Harrove fjalëkalimin?",
        forgotSub: "Shkruaj email-in dhe do të dërgojmë një lidhje për ta vendosur një të ri.",
        sendResetLink: "Dërgo lidhjen",
        sending: "Duke dërguar…",
        backToSignIn: "Kthehu te hyrja",
        resetTitle: "Vendos një fjalëkalim të ri",
        googleContinue: "Vazhdo me Google",
        orDivider: "ose",
        forgotPassword: "Harrove fjalëkalimin?",
        signUp: 'Regjistrohu',
        signIn: 'Hyr',
        eyebrow: 'Rezervo termin',
        tagline: 'Prerje premium',
        firstName: 'Emri',
        firstNamePlaceholder: 'Arben',
        lastName: 'Mbiemri',
        lastNamePlaceholder: 'Krasniqi',
        phone: 'Numri i telefonit',
        password: 'Fjalëkalimi',
        passwordPlaceholder: 'Të paktën 6 karaktere',
        confirmPassword: 'Konfirmo fjalëkalimin',
        confirmPlaceholder: 'Përsërit fjalëkalimin',
        passwordsNoMatch: 'Fjalëkalimet nuk përputhen',
        email: 'Email',
        emailPlaceholder: 'ti@shembull.com',
        contactRequired: 'Kërkohet të paktën një numër telefoni ose email.',
        createAccount: 'Krijo llogari',
        creatingAccount: 'Po krijohet llogaria…',
        terms: 'Duke vazhduar, ti pranon kushtet e {{shop}}.',
        identifierLabel: 'Numri i telefonit ose email',
        identifierPlaceholder: 'Numri ose email',
        identifierHint: 'Shkruaj numrin e telefonit ose emailin me të cilin u regjistrove.',
        continueBtn: 'Vazhdo',
        checking: 'Po kontrollohet…',
        passwordYour: 'Fjalëkalimi yt',
        signInBtn: 'Hyr',
        signingIn: 'Po hyn…',
        welcomeBack: 'Mirë se erdhe sërish, {{name}}',
        errNoAccount: 'Nuk u gjet asnjë llogari. Të lutem regjistrohu.',
        errEmailMismatch: 'Emaili nuk përputhet me llogarinë e regjistruar me këtë numër.',
        errSomethingWrong: 'Diçka shkoi keq. Provo përsëri.',
        forcePasswordTitle: 'Vendos një fjalëkalim të ri',
        forcePasswordIntro: 'Llogaria jote u krijua nga berberi. Për ta siguruar, vendos një fjalëkalim të ri që ta dish vetëm ti.',
        newPassword: 'Fjalëkalim i ri',
        savePassword: 'Ruaj fjalëkalimin',
        savingPassword: 'Po ruhet…',
    },

    welcome: {
        metaTitle: 'Softuer rezervimesh për berberë',
        navFeatures: 'Veçoritë',
        navHow: 'Si funksionon',
        navModules: 'Modulet',
        navPricing: 'Çmimet',
        navSignIn: 'Hyr',
        navBook: 'Rezervo termin',
        heroEyebrow: 'Për berberët dhe njerëzit që u besojnë',
        heroTitle: 'Rezervo berberin tënd.',
        heroTitleAccent: 'me tri klikime.',
        heroBigLine1: 'Rezervo orarin',
        heroBigLine2: 'që të përshtatet',
        heroBigLine3: 'për ty.',
        heroPill: 'Rezervimi, i ridizajnuar për berbere',
        heroSub: 'GetFade menaxhon rezervimet, klientët, orarin dhe dyqanin — që ti të fokusohesh te qethja.',
        heroSubMuted: 'Pa mesazhe. Pa rezervime të dyfishta. Pa çmime surprizë.',
        heroBadgeBooked: 'Rezervuar',
        heroBadgeRevenue: '+€280 sot',
        tickerLabel: 'I besuar nga dyqane të pavarura në të gjithë Evropën',
        directoryBadge: 'Së shpejti',
        directoryEyebrow: 'Gjej berberët pranë teje',
        directoryHeadline: 'Këtu do të listohen të gjithë berberët prej qyteve të ndryshme — secili me linkun e tij të veçantë.',
        directoryIntro: 'Shfleto berberët sipas qytetit. Filtro sipas stilit, çmimit dhe disponueshmërisë. Rezervo prerjen që dëshiron — kudo që je.',
        directoryCityLabel: 'Qyteti {{num}}',
        directoryCityTabsLabel: 'Qytetet',
        directoryExplainTitle: 'Çdo berber, në çdo qytet.',
        directoryExplainBody: 'Zgjidh një qytet dhe shfleto çdo berber që punon aty — shih stilet, çmimet dhe orarin e lirë, pastaj rezervo me një prekje.',
        howIntro: 'Nga fillimi në fund — më shpejt se sa lan një krehër.',
        howStepBigEnding: 'tënd.',
        featuresIntro: 'Kalendar, klientë, depozita, kujtesa, raporte. Një sistem i qetë, fund i historisë.',
        featuresEnding: 'Asgjë të tepërt.',
        featLabelCalendar: 'Kalendar',
        featLabelClients: 'Klientë',
        featLabelReminders: 'Kujtesa',
        featLabelReports: 'Raporte',
        featCalMonth: 'Prill',
        featCalYear: '2026',
        featNotifyNew: 'Rezervim i ri · 11:00',
        featNotifyNewSub: 'Marco · Skin fade',
        featNotifyReminder: 'Kujtesë e dërguar · 14:30',
        featNotifyReminderSub: 'James · Prerje + mjekër',
        featRevenueLabel: 'Këtë muaj',
        featRevenueAmount: '€4,280',
        featRevenueDelta: '+24%',
        clientName1: 'Marco Rossi',
        clientVisits1: '12 vizita',
        clientLast1: '3d më parë',
        clientName2: 'James Chen',
        clientVisits2: '8 vizita',
        clientLast2: '1j më parë',
        clientName3: 'Aiden Park',
        clientVisits3: '24 vizita',
        clientLast3: 'sot',
        previewWeekday: 'E mërkurë',
        previewDate: '29 Prill',
        previewBooked: '6 të rezervuara · 2 të lira',
        previewSideToday: 'Sot',
        previewSideCalendar: 'Kalendar',
        previewSideClients: 'Klientë',
        previewSideServices: 'Shërbime',
        previewSideReports: 'Raporte',
        previewSvcSkinFade: 'Skin fade',
        previewSvcCutBeard: 'Prerje + mjekër',
        previewSvcShave: 'Rrojë',
        previewSvcOpen: 'Termin i lirë',
        previewNow: 'Tani',
        previewAdd: '+ Shto',
        quoteText: 'Zëvendësuam',
        quoteHighlight: 'procesin',
        quoteAfter: 'me Getfade.',
        quoteAuthor: 'Marco Folsom',
        quoteAuthorMeta: 'Folsom & Sons · Londër',
        pricePopular: '★ Më i zgjedhuri',
        finalLine1: 'Prerja jote tjetër është',
        finalTaps: 'dy prekje',
        finalLine2: 'larg.',
        pricingHeadline1: 'Një çmim.',
        pricingHeadline2: 'Pa komision.',
        pricingIntro: 'Sa kërkon, aq mban. Ne nuk marrim pjesë nga prerja.',
        heroBook: 'Rezervo termin',
        heroForShops: 'Për dyqanet',
        previewTabBook: 'Rezervo',
        previewTabShops: 'Dyqanet',
        previewTabMy: 'Terminet e mia',
        previewLocation: 'Prishtinë',
        previewShopName: 'GetFade Barber Shop',
        previewShopMeta: '12 min ecje · ★ 4.9 (412)',
        previewService: 'Shërbimi',
        previewWhen: 'Kur',
        previewAvailable: 'Oraret e lira',
        previewConfirm: 'Konfirmo',
        previewSummary: 'Mar 28 · 11:00 · 60 min · €10',
        howEyebrow: 'Si funksionon',
        howTitle: 'Tre hapa,',
        howTitleAccent: 'gjej berberin tënd.',
        howTitleAccentLead: 'gjej berberin',
        howStep1Title: 'Gjej berberin tënd',
        howStep1Body: 'Kërko sipas lagjes, stilit ose berberit. Shiko prerje reale, çmime reale, vlerësime reale — asgjë e fryrë.',
        howStep2Title: 'Blloko terminin',
        howStep2Body: 'Zgjidh shërbimin, zgjidh kohën, mbaje me një depozitë të vogël. Riprogramo deri dy orë para terminit.',
        howStep3Title: 'Dil i freskët',
        howStep3Body: 'Lër bakshish, vlerëso prerjen, ribooko me një prekje. Berberi yt fiton një klient të rregullt.',
        featuresEyebrow: 'Për dyqanet',
        featuresTitle: 'Gjithçka që një berber ka nevojë.',
        featuresTitleAccent: 'Asgjë të tepërt.',
        feat1Title: 'Kalendari i karriges në kohë reale',
        feat1Body: 'Çdo karrige, çdo berber, çdo orar në një pamje të qetë. Tërhiqe për të riprogramuar, prekje për walk-in, kurrë rezervim të dyfishtë.',
        feat2Title: 'Depozita që mbahen',
        feat2Body: 'Merr një depozitë në rezervim, ktheje menjëherë në anulim, mbaje në mosparaqitje. Rregullat e tua, dyqani yt.',
        feat3Title: 'Memorja e klientit',
        feat3Body: 'Shënime për prerjen, fëmijën, dasmën e javës tjetër. Të ruajtura automatikisht. Asgjë nuk humbet mes vizitave.',
        feat4Title: 'Paneli i pronarit',
        feat4Body: 'Të ardhurat ditore, mbajtja e klientëve, ndarja e bakshisheve, shkalla e mosparaqitjes. Numrat që kontabilisti i kërkon, gati.',
        pricingEyebrow: 'Çmimet',
        pricingTitle: 'E thjeshtë.',
        pricingTitleAccent: 'Për dyqan.',
        priceFreeTag: 'Provë',
        priceFreeTitle: 'Falas për 3 muaj',
        priceFreeDesc: 'Provo të gjitha veçoritë pa kartë krediti.',
        priceFreeAmount: '€0',
        priceFreePer: 'për 3 muaj',
        priceFreeFeat1: 'Qasje e plotë në të gjitha veçoritë',
        priceFreeFeat2: 'Rezervime të pakufizuara',
        priceFreeFeat3: 'Pa kartë krediti',
        priceFreeFeat4: 'Anulo në çdo kohë',
        priceFreeCta: 'Fillo provën falas',
        pricePaidTag: 'Pro',
        pricePaidTitle: 'Gjithçka, pa kufij',
        pricePaidDesc: 'Për berberët dhe dyqanet që janë gati të rriten.',
        pricePaidAmount: '€10',
        pricePaidPer: '/ muaj',
        pricePaidYearNote: 'ose €100 / vit — kurse €20',
        pricePaidFeat1: 'Kalendari i karriges në kohë reale',
        pricePaidFeat2: 'Paneli i pronarit dhe raportet',
        pricePaidFeat3: 'Kujtesa SMS',
        pricePaidFeat4: 'Memorja dhe shënimet e klientit',
        pricePaidFeat5: 'Mbështetje me prioritet',
        pricePaidCta: 'Fillo tani',
        finalTitle: 'Prerja jote tjetër është',
        finalTitleAccent: 'dy prekje larg.',
        finalSub: 'Mos i shkruaj më berberit. Fillo ta rezervosh.',
        finalCtaList: 'Shto dyqanin tënd',
        footerTerms: 'Kushtet',
        footerPrivacy: 'Privatësia',
        footerContact: 'Kontakt',
        footerRights: 'Të gjitha të drejtat e rezervuara.',
        footerMadeBy: 'Krijuar nga',
        footerTagline: 'Sistemi i rezervimeve për berbere të pavarur.',
        appsHeading: 'Aplikacionet mobile',
        appsComingSoon: 'Së shpejti',
        appsAppStore: 'App Store',
        appsGooglePlay: 'Google Play',
        appsDownloadOn: 'Shkarko nga',
        appsGetItOn: 'Merre nga',
        footerProduct: 'Produkti',
        footerCompany: 'Kompania',
        footerLegal: 'Ligjore',
        navForBarbers: 'Për berberë',
        navResources: 'Burime',
        navStart: 'Fillo falas',
        heroLine1: 'Karrigia jote.',
        heroLine2: 'Plot me termine.',
        heroCta: 'Fillo falas',
        heroCtaAlt: 'Shih si funksionon',
        heroNote1: 'Pa kartë krediti',
        heroNote2: '3 muaj falas',
        heroNote3: 'Gati për pak minuta',
        devDate: 'Nesër',
        devToday: 'Sot',
        devNew: 'Rezervim i ri',
        devCollected: 'mbledhur këtë javë',
        devBookingsWeek: 'rezervime këtë javë',
        proofHead: 'Ndërtuar për berberë që s’duan të merren me mesazhe.',
        proofTrusted: 'Besuar nga 100+ berberë në botë',
        flowTitle1: 'Lehtë për klientët.',
        flowTitle2: 'Më shumë kohë për ty.',
        flowStep1: 'Zgjidh berberin',
        flowStep2: 'Zgjidh shërbimin',
        flowStep3: 'Zgjidh orën',
        flowStep4: 'Rezervimi u konfirmua',
        flowStep1Body: 'Klientët hapin linkun tënd të rezervimit dhe zgjedhin berberin.',
        flowStep2Body: 'Shërbimet, kohëzgjatja dhe çmimet, të qarta që në fillim.',
        flowStep3Body: 'Shfaqen vetëm oraret e lira, pa rezervime të dyfishta.',
        flowStep4Body: 'Rezervimi shfaqet menjëherë në kalendarin tënd.',
        flowNote: 'Linku yt GetFade. Funksionon në çdo telefon, në çdo kohë.',
        phChooseBarber: 'Zgjidh berberin',
        phSelectService: 'Zgjidh shërbimin',
        phPickTime: 'Zgjidh një orë',
        phBookNow: 'Rezervo tani',
        phBooked: 'U rezervua!',
        phWith: 'me',
        phAddCalendar: 'Shto në kalendar',
        phSeeDetails: 'Shih detajet',
        phDashboard: 'Paneli',
        phBookings: 'Rezervimet',
        phClients: 'Klientët',
        phNewBooking: 'Rezervim i ri',
        barberKicker: 'Për berberë',
        barberTitle1: 'Gjithë dita jote.',
        barberTitle2: 'Një ekran.',
        barberPoint1: 'Shih të gjitha rezervimet. Shmang mbivendosjet.',
        barberPoint2: 'Menaxho klientët pa termin dhe rezervimet.',
        barberPoint3: 'Qasje e shpejtë te klientët, shënimet dhe historiku.',
        barberPoint4: 'Mbaj ditën të organizuar dhe karrigen në punë.',
        barberCta: 'Shiko kalendarin',
        toolsTitle1: 'Të gjitha mjetet.',
        toolsTitle2: 'Të gjitha në një',
        toolsTitle3: 'vend.',
        toolBookings: 'Rezervimet',
        toolBookingsDesc: 'Rezervim online që mbush kalendarin.',
        toolCalendar: 'Kalendari',
        toolCalendarDesc: 'Orar në kohë reale. Pa mbivendosje.',
        toolClients: 'Klientët',
        toolClientsDesc: 'Profile klientësh, shënime dhe historik.',
        toolPayments: 'Pagesat',
        toolPaymentsDesc: 'Prano pagesa. Ndiq fitimet.',
        toolAnalytics: 'Analitika',
        toolAnalyticsDesc: 'Kupto dyqanin. Rrite biznesin.',
        toolBook: 'Rezervo',
        toolVisits: 'rezervime',
        toolEarnings: 'Fitimet totale',
        setupTitle1: 'Gati për punë në',
        setupTitle2: 'tre hapa.',
        setupLead: 'Pa instalim, pa kontratë. Krijo sallonin dhe merr rezervimin e parë sot.',
        setupCta: 'Fillo falas',
        setupStep1Title: 'Krijo profilin',
        setupStep1Body: 'Regjistrohu, shto emrin dhe foton e sallonit. Zgjat rreth dy minuta.',
        setupStep2Title: 'Shto shërbimet dhe oraret',
        setupStep2Body: 'Cakto çmimet, kohëzgjatjen dhe orarin e punës për çdo berber.',
        setupStep3Title: 'Prano rezervime 24/7',
        setupStep3Body: 'Ndaj linkun. Klientët rezervojnë vetë, ti njoftohesh menjëherë.',
        statsTitle1: 'Më shumë qethje.',
        statsTitle2: 'Më pak administratë.',
        statsLead: 'GetFade i ndihmon berberët të kursejnë kohë, të rrisin rezervimet dhe të ardhurat.',
        statsExample: 'Shembull ilustrues i panelit të GetFade.',
        statRev: 'Të ardhurat këtë muaj',
        statReturning: 'Klientë të kthyer',
        statBookings: 'Rezervime këtë muaj',
        statPeak: 'Oraret më të ngarkuara',
        statPeakValue: "Pre – Die",
        statVs: 'krahasuar me muajin e kaluar',
        appTitle1: 'Menaxho dyqanin.',
        appTitle2: 'Kudo.',
        appPoint1: 'Shih orarin e sotëm',
        appPoint2: 'Menaxho rezervimet',
        appPoint3: 'Shto klientë dhe shënime',
        appPoint4: 'Ndiq pagesat',
        appPoint5: 'Merr njoftime menjëherë',
        appDownload: 'Shkarko në',
        appGetOn: 'Merre në',
        closeTitle1: 'Gati për rezervimin',
        closeTitle2: 'tënd të radhës?',
        closeSub: 'Krijo faqen tënde GetFade për pak minuta.',
        closeCta: 'Fillo tani',
        closeFine: 'Pa kartë krediti.',
        footerBlurb: 'Software rezervimesh për berberë të pavarur.',
        footerBuilt: 'Ndërtuar për berberë.',
        footerAbout: 'Rreth nesh',
        footerSecurity: 'Siguria',
        proofStat1: 'berberë në GetFade',
        proofFactTrial: 'muaj falas për të filluar',
        proofFactPrice: 'në muaj pas kësaj',
        proofFactBooking: 'rezervime online për klientët e tu',
        proofStatBarbers: 'berberë në GetFade',
        proofStat2: 'vlerësimi mesatar',
        proofStat3: 'rezervime të bëra',
    },

    company: {
        pageTitle: 'Historia jonë',
        heroEyebrow: 'Historia jonë',
        heroLine1: 'Ndërtuar për zanatin.',
        heroLine2: 'Ndërtuar për berberët.',
        heroSub: 'GetFade nisi në karrigen e një berberi. Pamë berberë që humbnin klientë nga mesazhet e papërgjigjura, terminet e dyfishuara dhe mosparaqitjet. Prandaj ndërtuam mjetin që do të donim të ekzistonte.',

        missionEyebrow: 'Misioni',
        missionTitle: 'T\'i japim çdo berberi një shans të drejtë',
        missionBody: 'Zinxhirët e mëdhenj kanë ekipe softuerike. Berberët e pavarur jo. GetFade e barazon fushën me mjete profesionale që instalohen për minuta dhe përdoren për sekonda.',

        valuesEyebrow: 'Çfarë përfaqësojmë',
        valuesTitle: 'Vlerat tona',
        value1Title: 'Shpejtësia e para',
        value1Desc: 'Çdo funksion është krijuar për të kursyer kohë — tuajën dhe të klientëve tuaj.',
        value2Title: 'Privatësi si parazgjedhje',
        value2Desc: 'Të dhënat e klientëve janë tuajat. Ne kurrë nuk i shesim, nuk i ndajmë dhe nuk i përdorim për reklama.',
        value3Title: 'Ndërtuar për të gjithë',
        value3Desc: 'Kultura e berberëve është globale, po ashtu edhe ne.',
        value4Title: 'E udhëhequr nga komuniteti',
        value4Desc: 'Berberë realë formësojnë planin tonë. Çdo funksion i madh erdhi nga një kërkesë e klientit.',
        value5Title: 'Kujdesemi vërtet',
        value5Desc: 'Ne vetë përgjigjemi në mbështetje. Jo një bot. Jo një radhë biletash. Një person që i intereson.',
        value6Title: 'Fokus i plotë',
        value6Desc: 'Bëjmë një gjë — menaxhimin e berberhaneve. E bëjmë më mirë se kushdo.',

        ctaTitle1: 'Gati për t\'u',
        ctaTitle2: 'bashkuar me ne?',
        ctaSub: 'Hap llogarinë tënde falas sot. Pa kartë krediti, pa kontrata — thjesht një mënyrë më e mirë për të drejtuar dyqanin tënd.',
        ctaButton: 'Fillo falas',
    },

    modules: {
        pageTitle: 'Modulet & Konfigurimi',
        heroBadge: '11 module',
        heroBadgeText: 'Gjithçka që i duhet një salloni',
        heroLine1: 'Një platformë.',
        heroLine2: 'Çdo modul.',
        heroSub: 'GetFade ju jep sistemin e plotë operativ për një berberi — rezervimet, kalendari, klientët, pagesat dhe rritja — në një vend të vetëm.',

        booking: { title: 'Rezervime', desc: 'Kalendar i karriges në kohë reale. Klientët zgjedhin shërbimin, berberin dhe orarin — gati brenda një minute.' },
        barbers: { title: 'Berberët', desc: 'Menaxhoni ekipin tuaj — orarin, shërbimet për çdo berber, pushimet dhe rregullat e komisionit për karrige.' },
        customers: { title: 'Klientët', desc: 'Kujtesa e klientit: shënime për qethjen, fëmijët, dasmën e javës. Ruhen automatikisht.' },
        appointments: { title: 'Terminet', desc: 'Pamja ditore, rezervime me drag-to-reschedule, walk-in dhe ndryshim statusi me një klikim. Pa rezervime të dyfishta.' },
        services: { title: 'Shërbimet', desc: 'Menyja juaj — qethje, mjekër, peshqir i nxehtë, fëmijë. Vendosni kohëzgjatjen, çmimin dhe berberët që i ofrojnë.' },
        products: { title: 'Produktet', desc: 'Shitni pomadë, vaj mjekre dhe produkte të tjera në checkout. Inventari dhe njoftimet për stokun përfshihen.' },
        notifications: { title: 'Njoftimet', desc: 'Kujtues me email për klientët, si dhe njoftime të menjëhershme për rezervime dhe anulime për ekipin tënd — të automatizuara plotësisht.' },
        reports: { title: 'Raportet', desc: 'Të ardhurat ditore, mbajtja, ndarja e bakshisheve, niveli i no-show. Numrat që kërkon kontabilisti, gati.' },
        marketing: { title: 'Marketing', desc: 'Postime promocionale, sponsor marquee dhe fushata sezonale për të mbushur orët e qeta.' },
        qr: { title: 'Provo modelin me QR', desc: 'Një kod QR për rruajtoren tuaj. Klientët e skanojnë, provojnë modelet e flokëve me AI dhe rezervojnë modelin që pëlqejnë.' },
        settings: { title: 'Cilësimet', desc: 'Oraret, festat, rregullat e anulimit, gjuhët dhe lejet e ekipit.' },
        onboarding: { title: 'Onboarding', desc: 'Një magjistar i udhëzuar me 4 hapa për të konfiguruar sallonin, shërbimet dhe karrigen e parë në më pak se 5 minuta.' },

        setupLabel: 'Konfigurimi',
        setupTitlePart1: 'Online për',
        setupTitleAccent: 'më pak se 5 minuta',
        setupTitlePart2: '.',
        setupSub: 'Katër hapa. Pa nevojë për programues. Vetëm regjistrohuni dhe filloni të rezervoni.',
        step1Title: 'Krijoni llogarinë tuaj',
        step1Desc: 'Regjistrim në 30 sekonda. Pa kartë krediti.',
        step2Title: 'Shtoni sallonin tuaj',
        step2Desc: 'Oraret, adresa dhe gjuhët.',
        step3Title: 'Shtoni berberët & shërbimet',
        step3Desc: 'Ndërtoni ekipin dhe menynë tuaj — kohëzgjatjet dhe çmimet.',
        step4Title: 'Ndani lidhjen e rezervimeve',
        step4Desc: 'Shtojeni në Instagram, Google ose printoni QR-in.',

        ctaPrimary: 'Fillo falas',
        ctaBack: 'Kthehu në fillim',
        footerCopy: '© 2026 GetFade',
        footerPrivacy: 'Privatësia',
        footerTerms: 'Kushtet',
        footerSecurity: 'Siguria',
    },

    qrScan: {
        title: 'Skano kodin QR',
        subtitle: 'Drejto kamerën në kodin QR të berberit për të rezervuar termin',
        openCamera: 'Hap kamerën',
        clickToStart: 'Kliko për të filluar skanimin',
        notValid: 'Ky kod QR nuk është i vlefshëm. Provo një tjetër.',
        valid: 'Kodi QR i vlefshëm!',
        redirecting: 'Po të dërgon në faqen e rezervimit...',
        invalid: 'Kod QR i pavlefshëm',
        invalidDesc: 'Ky nuk duket të jetë një kod QR i vlefshëm rezervimi për berber.',
        tryAgain: 'Provo përsëri',
        howItWorks: 'Si funksionon',
        step1: 'Hap kamerën dhe drejtoje në një kod QR',
        step2: 'Kodi do të skanohet automatikisht',
        step3: 'Do të dërgohesh për të provuar prerjet me AI',
        pointCamera: 'Drejto kamerën në kodin QR',
        cameraError: 'Nuk mund të hyhet në kamerë. Kontrollo lejet.',
    },

    portal: {
        myAppointments: 'Terminet e mia',
        enterPhoneHint: 'Vendos numrin e telefonit për të parë historikun e rezervimeve.',
        phoneNumber: 'Numri i telefonit',
        lookingUp: 'Po kërkohet…',
        viewMyAppointments: 'Shiko terminet e mia',
        wantToBook: 'Dëshiron të rezervosh?',
        bookAppointment: 'Rezervo një termin',
        upcoming: 'Të ardhshme',
        noUpcoming: 'Nuk ka termine të ardhshme.',
    },
    appWelcome: {
        clientBook: 'Do të rezervosh? Gjej sallonin tënd',
        tag: 'Për berberë dhe pronarë',
        title: 'Menaxho sallonin nga telefoni',
        sub: 'Rezervimet, klientët dhe gjithë dita jote në një vend, me njoftim sapo dikush rezervon.',
        pointAlerts: 'Njoftim i menjëhershëm për rezervime',
        pointSchedule: 'Orari i ditës me një shikim',
        create: 'Krijo llogari',
        signIn: 'Hyr',
    },
    shopLink: {
        title: 'Rezervo te {{shop}} në GetFade',
        sub: 'Shkarko aplikacionin falas GetFade. Ai e hap {{shop}} sapo ta nisësh.',
        getApp: 'Shkarko GetFade',
        website: 'Rezervo në faqen e internetit',
    },
    appBook: {
        title: 'Rezervo një termin',
        sub: 'Skano kodin QR të sallonit tënd ose ngjit linkun e rezervimit.',
        scan: 'Skano kodin QR',
        or: 'ose',
        linkLabel: 'Linku i rezervimit',
        linkPlaceholder: 'getfade.io/book/salloni-yt',
        continue: 'Vazhdo',
        invalid: 'Ky nuk duket si link rezervimi i GetFade.',
        notFound: 'Nuk e gjetëm këtë sallon. Kontrollo linkun dhe provo përsëri.',
        yourShops: 'Sallonet e tua',
        staffPrompt: 'Je berber ose pronar salloni?',
        staffLink: 'Hyr',
    },
} as const;
